import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, TemplateRef, ViewChild, OnDestroy } from '@angular/core';
import { NavigationEnd, Router, ActivatedRoute } from '@angular/router';
import { filter, takeUntil } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { Location, DatePipe } from '@angular/common';
import { FormBuilder, FormControl, FormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfirmYesNoDialogComponent } from './confirm-yes-no-dialog/confirm-yes-no-dialog.component';
import { LeadActivityService } from 'src/app/services/lead-activity.service';
import { UsersService } from 'src/app/services/users.service';
import { LeadStatusService } from 'src/app/services/lead-status.service';
import { LeadService } from 'src/app/services/lead.service';
import { CrmsettingsService } from 'src/app/services/crmsettings.service';
import { CrmNoteService } from 'src/app/services/crm-note.service';
import { ConversationPopupComponent } from 'src/app/shared/conversation-popup/conversation-popup.component';
import { TransferLeadComponent } from 'src/app/shared/transfer-lead/transfer-lead.component';
import { Constant } from 'src/app/constant/constant';
import { CrmNoteComponent } from 'src/app/shared/crm-note/crm-note.component';
import { CallListComponent } from 'src/app/shared/call-list/call-list.component';
import { BehaviorSubject, Subject } from 'rxjs';
import { SearchBuilderComponent } from 'src/app/shared/search-builder/search-builder.component';
import { environment } from 'src/environments/environment';
import { ProductService } from 'src/app/services/product.service';
import { CategoriesService } from 'src/app/services/categories.service';
import { downloads, getPageSize, ResourceAccess } from 'src/app/shared/utils/calsoft-validators';
import { DynamicFormLabelService } from 'src/app/services/dynamic-form-label.service';
import icPhone from '@iconify/icons-ic/twotone-phone';
import icWhatsapp from '@iconify/icons-mdi/whatsapp';
import { ConfigService } from 'src/app/services/config.service';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { EditprofileComponent } from './editprofile/editprofile.component';
import { LoaderService } from 'src/app/services/loader.service';
import { EmailPopupComponentComponent } from './email-popup-component/email-popup-component.component';
import { EcryptServiceService } from 'src/app/core/auth/EcryptionService/ecrypt-service.service';
import { EmailSendService } from 'src/app/services/email-send.service';
import { MailBoxService } from 'src/app/services/mail-box.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { LeadActivityListService } from 'src/app/services/lead-activity-list.service';
import { SimpleDynamicFormComponent } from 'src/app/shared/simple-form/simple-dynamic-form/simple-dynamic-form.component';
import { TemplateServiceService } from 'src/app/services/template-service.service';
import { UserMailConfigService } from 'src/app/services/user-mail-config.service';
import { DealsService } from 'src/app/services/deals.service';
import { GoogleCalendarServiceAccountService } from 'src/app/services/google-calendar-service-account.service';
import { CommonService } from 'src/app/services/common.service';
import { ProfileEditorDialogComponent } from './profile-editor-dialog/profile-editor-dialog.component';
import { FileUploadPopupComponent } from '../../file-upload-popup/file-upload-popup.component';
import { DownloadImageService } from 'src/app/services/download-image.service';
import { TagesStatusService } from 'src/app/services/tages-status.service';
import { AddMeetingComponent } from '../../companies/add-meeting/add-meeting.component';
import { PopupEditComponent } from 'src/app/shared/popup-edit/popup-edit.component';
import { ActivityService } from 'src/app/services/activity.service';
import { FieldEditDialogComponent } from './field-edit-dialog/field-edit-dialog.component';
import { element } from 'protractor';
import { SendSmsPopupComponent } from './send-sms-popup/send-sms-popup.component';
import { TwilloDialerComponent } from '../../phone-dialer/twillo-dialer/twillo-dialer.component';
import { DocumentService } from 'src/app/services/document.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { FieldDesignerService } from 'src/app/services/field-designer.service';
import { V } from '@angular/cdk/keycodes';
import { AddSiteVisitComponent } from '../add-site-visit/add-site-visit.component';

export interface PipelineStep {
  stage: string;
  name: string;
  status: any;
}

export interface ActionCard {
  icon: string;
  title: string;
  links: { text: string; type: 'link' | 'button' }[];
}

export interface LeadDetails {
  lifecycleStage: string;
  pipeline: PipelineStep[];
  isKeyStakeholder: boolean;
  location: string;
  account: string;
  email: string;
  mobile: string;
  salesOwner: string;
  createdAt: string;
  actionCards: ActionCard[];
}

@Component({
  selector: 'calsoft-lead-detail',
  templateUrl: './lead-detail.component.html',
  styleUrls: ['./lead-detail.component.scss'],
  animations: [
    trigger('expandCollapse', [
      state('collapsed', style({ height: '0px', overflow: 'hidden', opacity: 0 })),
      state('expanded', style({ height: '*', opacity: 1 })),
      transition('collapsed <=> expanded', animate('300ms ease-in-out'))
    ])
  ]
})

export class LeadDetailComponent implements OnInit, OnDestroy {

  basePath = environment.commonImageApi + '/profile/'
  cid: any;
  url = '';
  sanitizedUrl = '';


  icPhone = icPhone;
  icWhatsapp = icWhatsapp;
  whatsapplogs = "e124595e-81d7-4e4c-81df-e3e1a6f2263b";
  tabs = [
    { name: 'Overview', icon: 'grid_view' },
    { name: 'My Views', icon: 'user_attributes' },
    { name: 'Contact details', icon: 'person' },
    // { name: 'Conversations', icon: 'chat' },
    { name: 'Activities', icon: 'task_alt' },
    { name: 'Company', icon: 'domain' },
    { name: 'Deals', icon: 'monetization_on' },
    { name: 'Next Action', icon: 'psychology' },
    { name: 'Files', icon: 'folder' },


  ];





  isCollapsed = false;
  hoveredField: any = null;
  selectedField: any = null;
  editOptions = ['Edit Text', 'Change Value', 'Remove'];

  fields = [
    { label: 'Email', value: 'bh@hubspot.com' },
    { label: 'Phone number', value: '' },
    { label: 'Preferred channels', value: '' },
    { label: 'Favorite Content Topics', value: '' },
    { label: 'Lead status', value: '' },
    { label: 'Create date', value: '02/22/2025 2:00 PM GMT+5:30' },
  ];
  dynamicFields = []

  // Mapping of search keywords to their respective tabs
  fieldTabMapping: { [key: string]: string } = {};
  useIndividualMail: any = 0;

  buildDynamicFieldMapping() {
    // Default mappings for common fields
    const defaultMapping = {
      'call duration': 'My Views',
      'status': 'Contact details',
      'lifecycle stage': 'Overview',
      'category': 'Contact details',
      'product': 'Contact details',
      'lead source': 'Contact details'
    };

    this.fieldTabMapping = { ...defaultMapping };

    // Dynamically include fields from categories often found in "Contact details"
    const dataSources = [
      this.usedInSite,
      this.filterList,
      this.additionalSpec,
      this.LeadDetailsObject?.isCustomizedValue
    ];

    dataSources.forEach(source => {
      if (source && typeof source === 'object') {
        Object.keys(source).forEach(key => {
          const lowerKey = key.toLowerCase();
          if (!this.fieldTabMapping[lowerKey]) {
            this.fieldTabMapping[lowerKey] = 'Contact details';
          }
        });
      }
    });

    // Root properties of LeadDetailsObject that are typically in Contact details
    const rootProperties = ['name', 'email', 'mobile', 'phoneNumber', 'secondaryphoneno', 'jobtitle', 'company', 'industry', 'website', 'country', 'city', 'state', 'zipcode', 'pincode', 'ownerIdName'];
    rootProperties.forEach(prop => {
      const lowerProp = prop.toLowerCase();
      if (!this.fieldTabMapping[lowerProp]) {
        this.fieldTabMapping[lowerProp] = 'Contact details';
      }
    });

    // Also include form group field names
    if (this.firstFormGroup) {
      Object.keys(this.firstFormGroup.controls).forEach(key => {
        const lowerKey = key.toLowerCase();
        if (!this.fieldTabMapping[lowerKey]) {
          this.fieldTabMapping[lowerKey] = 'Contact details';
        }
      });
    }
  }
  fieldstwo = [
    { label: 'Email', value: 'bh@hubspot.com' },
    { label: 'Phone number', value: '' },
    { label: 'Preferred channels', value: '' },
    { label: 'Favorite Content Topics', value: '' },
    { label: 'Lead status', value: '' },
    { label: 'Create date', value: '02/22/2025 2:00 PM GMT+5:30' },
  ];
  sections = [
    {
      title: 'Breeze record summary',
      isOpen: true, // This section is open by default
      isSpecial: true // To handle the unique layout of the summary
    },
    {
      title: 'Companies',
      count: 1,
      action: '+ Add',
      isOpen: false,
      content: 'Primary HubSpot hubspot.com Phone: --',
      hasCompanyInfo: true
    },
    { title: 'Deals', count: 0, action: '+ Add', isOpen: false, content: 'Track the revenue opportunities associated with this record.' },
    { title: 'Tickets', count: 0, action: '+ Add', isOpen: false, content: 'Track the customer requests associated with this record.' },
    {
      title: 'Payment Links',
      count: 0,
      action: 'Add',
      isDropdownAction: true,
      isOpen: false,
      content: 'Give customers a fast, flexible way to pay. Add a payment link to accept a payment and associate it with this record.',
      hasButton: true,
      buttonText: 'Set up payments'
    },
    { title: 'Contacts', count: 0, action: '+ Add', isOpen: false, content: 'See the people associated with this record.' },
    {
      title: 'Subscriptions',
      count: 0,
      action: 'Add',
      isDropdownAction: true,
      isOpen: false,
      content: 'Automate subscription management and recurring billing from this record.',
      hasButton: true,
      buttonText: 'Set up payments'
    },
    {
      title: 'Payments',
      count: 0,
      action: null,
      isOpen: false,
      content: 'Track payments associated with this record. A payment is created when a customer pays or a recurring payment is processed through HubSpot.',
      hasButton: true,
      buttonText: 'Set up payments'
    },
    { title: 'Orders', count: 0, action: '+ Add', isOpen: false, content: 'See the Orders associated with this record.' },
    { title: 'Carts', count: 0, action: '+ Add', isOpen: false, content: 'See the Carts associated with this record.' },
    { title: 'Social profiles', count: null, action: 'Manage', isOpen: false, content: 'See the Social profiles associated with this record.' },
    {
      title: 'Attachments',
      count: null,
      action: 'Add',
      isDropdownAction: true,
      isOpen: false,
      content: 'See the files attached to your activities or associated with this record.'
    },
  ];
  @Input() groupBy: any = 'activityType';
  showEditIcon = false;
  isEditMenuOpen = false;
  name = 'Pavithran Rajendran';
  search: string;
  calllist: any;
  dialerType: any;
  authorizationToken: string = '';
  frejunEmail: string = '';
  dialerVisible: boolean = false;
  dialerLoaded: boolean = false;
  authRequired: boolean = false;
  updateType: string = null;
  pageSize: any;
  totalSize: any;
  leadActivityListFinal: Object;
  isEmpty: any;
  onScrollValue: boolean = true;
  displayOwner: boolean = false;
  leadLoaded: boolean = false;


  //for email
  emails: any[] = [];
  selectedEmail: any = null;
  currentMailBox: string = 'INBOX';
  pageIndex = 0;
  pageSizeEmail = 10;
  totalEmails = 0;
  isLoading = false;
  enableDynamicTabs: any;
  leadActivityDropDowns: Object;
  leadTabs: any;
  emailObject: any;
  emailVisble: boolean = false;
  defaultForms: any = 0;
  baseUrl: any;

  public newserverpath: string = '';
  isCollapsedtwo: boolean;
  taskCounts = {
    all: 0,
    upcoming: 0,
    overdue: 0,
    completed: 0
  };
  noOfDeals: any;
  noOfMeetings: any;
  dealSetId: any;
  defaultSet: any;
  defaultSetType: any;
  relatedCompanyId: any;
  relatedLeadId: any;
  meetingType: any = 1;
  uploadedImageUrl: string;
  totalActivity: any;
  taskType: any;
  tagObject: { entityId: any; TagId: any; tagName: any; };
  tagSave: string;
  leadInvoiceType: any = 1;
  leadQuotationType: any = 1;
  notesType: any;
  lifeCycleStage: any;
  activeViewNew: 'Original' | 'basic' = 'basic';
  encryptPhone: any;
  encryptEmail: any;
  whatAppchatType: any;
  previousValue: any;
  webMobileCallEnable: any = 0;
  manageFieldCustomization: any = 0;


  toggleEditMenu(event: Event) {
    event.stopPropagation(); // Prevent unwanted clicks closing the menu
    this.isEditMenuOpen = !this.isEditMenuOpen;
  }

  saveEdit() {
    this.isEditMenuOpen = false; // Close menu after saving
  }
  generateTooltip(step: any) {
    return `Lead Status Name : ${step.statusName}`;
  }
  showToContactDetials() {
    this.setActiveTab("Contact details")
  }
  updateLeadStatus(step: any) {

    if (this.LeadDetailsObject.statusName === step.statusName) {
      return;
    }

    // Update the form’s LeadStatus to the clicked step
    this.firstFormGroup.patchValue({
      LeadStatus: step.statusId
    });

    this.LeadDetailsObject.statusName = step.statusId;
    this.currentStatusIndex = this.filtereddropdownTypeList.findIndex(
      s => s.statusName === step.statusName
    );

    // Save to backend using your existing function
    this.saveLead();
  }
  openDeals = [
    { name: 'Widgetz.io (sample)', value: 5600, status: 'New', closes: 'Closes in Oct' }
  ];

  setActiveTab(tabName: string): void {
    this.activeTab = tabName;
    const scrollToTop = () => {
      try {
        window.scrollTo({ top: 0, behavior: 'auto' });
        const scrollContainers = document.querySelectorAll('.content, .right-content-area, .dynamic-content, mat-sidenav-content');
        scrollContainers.forEach(container => {
          const originalScrollBehavior = (container as HTMLElement).style.scrollBehavior;
          (container as HTMLElement).style.scrollBehavior = 'auto';
          container.scrollTop = 0;
          (container as HTMLElement).style.scrollBehavior = originalScrollBehavior;
        });
      } catch (e) {
        console.error('Error scrolling to top:', e);
      }
    };
    scrollToTop();
    setTimeout(scrollToTop, 0);
  }
  isPopupVisible = false;
  isEditing = false;

  // Holds the data for the note being created or edited in the popup
  currentNoteData: Partial<any> = { notes: '' };

  // Set to keep track of which notes are expanded
  private expandedNotes = new Set<number>();

  openPopup(note?: any): void {
    if (note) {
      // EDIT MODE
      this.isEditing = true;
      // Create a copy to avoid modifying the original object directly
      this.currentNoteData = { ...note };
    } else {
      // CREATE MODEfjsonRecieved
      this.isEditing = false;
      this.currentNoteData = { notes: '', documentType: 0 };
    }
    this.isPopupVisible = true;
  }

  closePopup(): void {
    this.isPopupVisible = false;
  }
  saveNote(): void {
    if (this.isEditing) {

      this.createNote(this.currentNoteData as any, this.currentNoteData.noteId!);
    } else {

      this.createNote(null, 0);
    }
    this.closePopup();
  }
  toggleShowMore(noteId: number): void {
    if (this.expandedNotes.has(noteId)) {
      this.expandedNotes.delete(noteId);
    } else {
      this.expandedNotes.add(noteId);
    }
  }

  isExpanded(noteId: number): boolean {
    return this.expandedNotes.has(noteId);
  }

  loading: boolean = false;


  saveField(field: any) {
    this.loading = true;

    // Simulating API call or saving logic
    setTimeout(() => {
      this.loading = false;
      this.editMode = null; // Exit edit mode after saving
    }, 2000); // Simulating delay
  }
  toggleSection(section: any): void {
    section.isOpen = !section.isOpen;
  }

  toggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
  }

  openEditMenu(field: any, event: MouseEvent) {
    this.selectedField = field;
    event.stopPropagation();
  }

  editField(field: any, option: string) {
    console.log(`Editing ${field.label}: ${option}`);
  }


  copyEmail() {
    const email = document.querySelector(".details-email-container").firstChild.textContent.trim();
    navigator.clipboard.writeText(email).then(() => {
      alert("Copied to clipboard: " + email);
    }).catch(err => {
      console.error("Failed to copy: ", err);
    });
  }

  selectedTab = 'activities';

  // Sample data for each tab
  tabData: { [key: string]: string } = {
    activities: 'This is the Activities content.',
    notes: 'This is the Notes content.',
    calls: 'This is the Calls content.',
    files: 'This is the Files content.',
    email: 'This is the Email content.'
  };

  leadDetailPageType: any;

  selectTab(tabId: string): void {
    this.selectedTab = tabId;
  }

  leadActivityList: any = [];

  init: boolean = false;

  LeadDetailsObject: any;
  leadId: any;

  public editMode = false;
  // Global inline edit flag for profile card (leadDetailPageType === 6)
  public isEditMode: boolean = false;
  leadStatusList: any;

  public selectedLeadStatus: string;
  text: string = "Save";

  leadAge: string;
  textAccount: string;
  leadPropertiesName: any;
  leadAdditionalPropertiesName: any;
  leadCommonPropertiesName: any;
  leadNoteDisplay: any;
  leadAdditionalPropertiesDisplay: any;
  leadCommonPropertiesDisplay: any;
  leadPropertiesDisplay: any;
  additionalSpec: any;
  filterList: any;

  noteList: any = [];
  replyingToNoteId: number | null = null;
  replyText: string = '';
  usedInSite: any;
  jsonRecieved: any;
  id: any;
  activityId: any;
  textCall: string;
  ownerId: any;
  type1: boolean = false;
  additionalSpecList: any = [];
  type2: boolean = false;
  valuesList: any = [];
  type3: boolean = false;
  customList: any = [];
  crmType: any;
  dialerShow: boolean = false;
  customField1: any;
  customField2: any;

  customField3: any;
  customField4: any;
  customField5: any;
  customField6: any;
  customField7: any;
  customField8: any;
  customField9: any;
  customField10: any;


  additionalData: boolean = false;
  additionalAttributeName: any;
  additionalAttributeEnable: any = 0;
  enableInvoiceInLead: any = 0;
  newType: number = 1;

  finalValueForm: any = {};
  patchValues: any;
  formInit: boolean = false;
  sameLeadName: boolean;
  emailValue: any;
  phoneValue: any;
  whatsAppCustomUrl: any;
  whatAppUrl: any;
  storeName: any;
  data: any;
  GridType: any;

  defaultForm: boolean = false;

  constructor(private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private googleCalendarServiceAccountService: GoogleCalendarServiceAccountService,
    private dealsService: DealsService,
    private mailboxService: MailBoxService,
    private leadActivityListSerive: LeadActivityListService,
    private leadActivityService: LeadActivityService,
    private ecryptService: EcryptServiceService,
    private dialog: MatDialog,
    private leadStatusService: LeadStatusService,
    private fb: FormBuilder,
    private snackBar: MatSnackBar,
    private leadService: LeadService,
    private crmsettingsService: CrmsettingsService,
    private crmNoteService: CrmNoteService,
    private productService: ProductService,
    public location: Location,
    private router: Router,
    private dynamicFormLabelService: DynamicFormLabelService,
    private changeDetector: ChangeDetectorRef,
    private configService: ConfigService,
    private loaderService: LoaderService,
    private emailSendService: EmailSendService,
    private mailBox: MailBoxService,
    private templateService: TemplateServiceService,
    private commonService: CommonService,
    private downloadImageService: DownloadImageService,
    private tagesStatusService: TagesStatusService,
    private activityService: ActivityService,
    private documentService: DocumentService,
    private fieldDesignerService: FieldDesignerService,
    private usersService: UsersService,
    private userMailConfigService: UserMailConfigService,
    private categoriesService: CategoriesService,
  ) {
    this.url = this.router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
    });

  }

  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }




  public serverPathEmail = environment.commonImageApi + 'gmail/';

  public serverPath = environment.commonImageApi + '/courseAudio/';

  public serverPathImage = environment.commonImageApi + 'courseImage/';

  public serverPathPdf = environment.commonImageApi + 'coursepdf/';

  public serverPathVedio = environment.commonImageApi + '/courseVideo/';

  public serverPathNotes = environment.commonImageApi + 'crmFiles/';

  modifiedname: any;

  textSend: string;

  textSubmit: String;

  userId: any;
  companyId: any;

  filterTabsForDeal() {
    if (this.isDealView) {
      if (this.tabs) {
        this.tabs = this.tabs.filter(t => t.name.toLowerCase() === 'overview' || t.name.toLowerCase() === 'activities');
      }
      if (this.leadTabs) {
        this.leadTabs = this.leadTabs.filter(t => t.name.toLowerCase() === 'activity history' || t.name.toLowerCase() === 'activity');
      }
    }
  }
  isDealView: boolean = false;

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params['type'] === 'deal') {
        this.isDealView = true;
        this.filterTabsForDeal();
      }
    });
    const encryptedData = localStorage.getItem('crmSettingsData');
    if (encryptedData) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encryptedData);
        const data = JSON.parse(decrypted);
        if (data != null) {
          this.useIndividualMail = data['useIndividualMail'];
          if (this.useIndividualMail == 1) {
            this.fromEmailId.setValidators([Validators.required]);
            this.fromEmail.setValidators([Validators.required]);
          } else {
            this.fromEmailId.clearValidators();
            this.fromEmail.clearValidators();
          }
          this.fromEmailId.updateValueAndValidity();
          this.fromEmail.updateValueAndValidity();
        }
      } catch (error) {
        console.error("Failed to decrypt crmSettingsData in ngOnInit:", error);
      }
    }

    this.checkMobile();

    window.addEventListener('resize', this.checkMobile.bind(this))

    //for email

    let val = parseInt(localStorage.getItem(Constant.SU))

    if (isNaN(val)) {
      val = 0;
    }

    if (val > 0) {

      this.displayOwner = true;

    } else {
      this.displayOwner = false;
    }

    this.dynamicFields = [
      { icon: 'star_border', property: 'name', formControlName: 'Name', placeholder: 'Name', editMode: false },
      { icon: 'mail', property: 'email', formControlName: 'Email', placeholder: 'Email', editMode: false },
      { icon: 'call', property: 'phoneNumber', formControlName: 'PhoneNumber', placeholder: 'Phone Number', editMode: false },
      { icon: 'location_on', property: 'Address', formControlName: 'Address', placeholder: 'Address', editMode: false },
      { icon: 'person_outline', property: 'CrName', formControlName: 'CrName', placeholder: 'Cr Name', editMode: false },
      { icon: 'assignment', property: 'CrNo', formControlName: 'CrNo', placeholder: 'Cr No', editMode: false }
    ];

    this.modifiedname = localStorage.getItem('authenticaterUserEmail') || '';
    this.selectedTab = "activities";
    this.leadId = this.route.snapshot.params['leadId'];


    this.selectTab(this.selectedTab);
    this.getAllLeadDetails(this.leadId)
    this.createFormGroup();
    this.getAllDocument();

    this.route.params.pipe(takeUntil(this._onDestroy)).subscribe(params => {
      if (params['leadId']) {
        const newLeadId = params['leadId'];
        if (this.leadId !== newLeadId) {
          this.leadId = newLeadId;
          this.selectTab(this.selectedTab);
          this.getAllLeadDetails(this.leadId);
          this.getAllDocument();
        }
      }
    });
    this.textAccount = 'OK';

    this.textCall = 'Call'

    this.textSend = "Send";

    this.textSubmit = "Submit";


    this.tagSave = "Save";

    this.dialerShow = false;


    let values = localStorage.getItem(Constant.enterPriseKey);

    this.cid = "&cid=" + values

    this.getEmailTemplateMessageList();

    this.EmailTemplateMessageYFilter();

    this.getAllUserMailConfig();

    this.typeEmailYFilter();

    this.getAllTags();

    this.TagsYFilter();

    this.userId = localStorage.getItem('userId');
    this.companyId = localStorage.getItem('storeName');
    this.isCollapsedtwo = true;
    this.getCount();
    this.getResource();

    this.initializeFilteredData();

    this.getAllManageContactFields();
    this.getSalesOwners();

  }

  toggleEditMode() {
    this.isEditMode = !this.isEditMode;
  }

  saveAllProfileEdits() {
    // Patch form controls from the inline-edited LeadDetailsObject then save
    if (!this.firstFormGroup) { this.createFormGroup(); }

    try {
      this.firstFormGroup.patchValue({
        Name: this.LeadDetailsObject?.name,
        Email: this.LeadDetailsObject?.email,
        PhoneNumber: this.LeadDetailsObject?.phoneNumber,
        Address: this.LeadDetailsObject?.address || this.firstFormGroup.value.Address,
        CrName: this.LeadDetailsObject?.CrName || this.firstFormGroup.value.CrName,
        CrNo: this.LeadDetailsObject?.CrNo || this.firstFormGroup.value.CrNo,
        LeadStatus: this.LeadDetailsObject?.statusId || this.firstFormGroup.value.LeadStatus,
        Owner: this.LeadDetailsObject?.ownerId || this.firstFormGroup.value.Owner,
      });
    } catch (e) {
      // swallow if patching fails; still attempt to save
    }

    // call existing saveLead that persists firstFormGroup values and finalValueForm
    this.saveLead();

    // editing disabled once saveLead succeeds (handled in saveLead success)
  }

  // Sales owners list for owner select in edit mode
  salesOwners: any[] = [];

  getSalesOwners() {
    try {
      this.usersService.getAllUserStatusDropDownSales().subscribe(
        (res: any) => {
          this.salesOwners = res || [];
        },
        (err) => { }
      );
    } catch (e) { }
  }

  onOwnerChange(selectedOwnerId: any) {
    if (selectedOwnerId === undefined || selectedOwnerId === null || selectedOwnerId === '') { return; }
    const owner = this.salesOwners.find((o: any) => String(o.entityId) == String(selectedOwnerId) || String(o.ownerId) == String(selectedOwnerId) || String(o.OwnerId) == String(selectedOwnerId));
    if (owner) {
      this.LeadDetailsObject.ownerId = String(owner.entityId || owner.ownerId || owner.OwnerId);
      this.LeadDetailsObject.ownerIdName = owner.email || owner.ownerEmail || owner.OwnerName || owner.name;
      if (!this.firstFormGroup) { this.createFormGroup(); }
      this.firstFormGroup.patchValue({ Owner: this.LeadDetailsObject.ownerId });
    }
  }

  onStatusChange(selectedStatusId: any) {
    if (selectedStatusId === undefined || selectedStatusId === null || selectedStatusId === '') { return; }
    const status = (this.filtereddropdownTypeList || []).find((s: any) => String(s.statusId) == String(selectedStatusId) || String(s.id) == String(selectedStatusId));
    if (status) {
      this.LeadDetailsObject.statusId = String(status.statusId || status.id);
      this.LeadDetailsObject.statusName = status.statusName;
      if (!this.firstFormGroup) { this.createFormGroup(); }
      this.firstFormGroup.patchValue({ LeadStatus: this.LeadDetailsObject.statusId });
    }
  }


  crmConfig: any;

  activityHistoryType: any = 0;



  getResource() {
    this.commonService
      .getAllAccessForResource(ResourceAccess.LEAD)
      .subscribe((data: any) => {

        if (!data.read) {
          this.router.navigate(['/unauthorized']);
        } else {

          this.resourcePrivilege = data;



        }
      });
  }




  checkMobile() {
    this.isMobileView = window.innerWidth <= 768;
  }


  backToList() {
    this.emailVisble = false;
  }


  taskButtonEnable: any = true;

  leadActionsbuttonEnable: any = true;

  sendEmailbutttonEnable: any = true;

  sendEmailTemplateEnable: any = true;

  sendSmsEnable: any = true;

  documentEnable: any = true;

  builderSearchPopupEnable: any = false;

  invoicebuttonEnable: any = true;

  quotationbuttonEnable: any = true;

  taskButtonName: any = 'Task'

  activeRetry: any = null;
  activeRetrySteps: any[] = [];
  retrySpinner: boolean = false;

  leadActionsbutton: any = 'Lead Actions'

  sendEmailbuttton: any = 'Send Email'

  sendEmailTemplate: any = 'Email Template'

  sendSms: any = 'Send Sms'

  document: any = 'Document'

  builderSearchPopup: any = 'Search'

  invoicebutton: any = 'Invoice'

  quotationbutton: any = 'Quotation'

  getAllLeadActivityList() {
    this.type8Loading = true;

    this.leadActivityListSerive.getAllLeadActivityListDropDown().subscribe(
      res => {
        this.type8Loading = false;
        if (this.leadDetailPageType == 7) {
          if (res && Array.isArray(res) && res.length > 0) {
            const activeSections = res
              .filter((s: any) => (s.active === undefined || s.active === null || Number(s.active) === 1 || s.active === true || s.active === '1') && (s.visible === undefined || s.visible === null || Number(s.visible) === 1 || s.visible === true || s.visible === '1'))
              .sort((a: any, b: any) => Number(a.position || 0) - Number(b.position || 0));

            activeSections.forEach((s: any) => {
              const mappers = s.leadActivityListMapper || s.leadActivityListMappers || s.activityListMapper || s.leadActivityMappers || s.mappers || [];
              if (Array.isArray(mappers)) {
                s.leadActivityListMapper = mappers
                  .filter((m: any) => (m.active === undefined || m.active === null || Number(m.active) === 1 || m.active === true || m.active === '1') && (m.visible === undefined || m.visible === null || Number(m.visible) === 1 || m.visible === true || m.visible === '1'))
                  .sort((a: any, b: any) => Number(a.position || 0) - Number(b.position || 0));
              } else {
                s.leadActivityListMapper = [];
              }
            });
            this.type8Sections = activeSections.length > 0 ? activeSections : this.getDefaultType8Sections();
          } else {
            this.type8Sections = this.getDefaultType8Sections();
          }

          if (this.type8Sections.length > 0) {
            const currentSectionId = this.activeType8Section?.activityListId;
            const stillActive = currentSectionId ? this.type8Sections.find((s: any) => s.activityListId === currentSectionId) : null;
            this.selectType8Section(stillActive || this.type8Sections[0]);
          } else {
            this.activeType8Section = null;
            this.activeType8ChildTab = null;
            this.activeType8ComponentKey = '';
          }
        }

        this.leadActivityDropDowns = res;
        this.leadTabs = this.leadActivityDropDowns;
        this.filterTabsForDeal();

        // Find the 'activities' parent and extract active children
        const activitiesParent = this.leadTabs && Array.isArray(this.leadTabs) ? this.leadTabs.find((x: any) => x.name === 'activities') : null;
        if (activitiesParent && activitiesParent.leadActivityListMapper) {
          this.activityTabs = activitiesParent.leadActivityListMapper
            .filter((x: any) => Number(x.active) === 1)
            .sort((a: any, b: any) => Number(a.position || 0) - Number(b.position || 0));
        } else {
          this.activityTabs = [];
        }

        if (this.activityTabs.length > 0 && this.activityTabs[0]?.name) {
          this.selectTabInner(this.activityTabs[0].name);
        } else {
          this.selectTabInner('activity');
        }

        if (this.leadTabs && Array.isArray(this.leadTabs)) {
          let index = this.leadTabs.findIndex(x => x.name === 'taskbutton');
          if (index < 0) {
            this.taskButtonEnable = false;
          } else {
            this.taskButtonName = this.leadTabs[index]['label'];
            this.leadTabs.splice(index, 1);
          }

          index = this.leadTabs.findIndex(x => x.name === 'leadActionsbutton');
          if (index < 0) {
            this.leadActionsbuttonEnable = false;
          } else {
            this.leadActionsbutton = this.leadTabs[index]['label'];
            this.leadTabs.splice(index, 1);
          }

          index = this.leadTabs.findIndex(x => x.name === 'sendEmailbuttton');
          if (index < 0) {
            this.sendEmailbutttonEnable = false;
          } else {
            this.sendEmailbuttton = this.leadTabs[index]['label'];
            this.leadTabs.splice(index, 1);
          }

          index = this.leadTabs.findIndex(x => x.name === 'sendEmailTemplate');
          if (index < 0) {
            this.sendEmailTemplateEnable = false;
          } else {
            this.sendEmailTemplate = this.leadTabs[index]['label'];
            this.leadTabs.splice(index, 1);
          }

          index = this.leadTabs.findIndex(x => x.name === 'sendSms');
          if (index < 0) {
            this.sendSmsEnable = false;
          } else {
            this.sendSms = this.leadTabs[index]['label'];
            this.leadTabs.splice(index, 1);
          }


          index = this.leadTabs.findIndex(x => x.name === 'document');
          if (index < 0) {
            this.documentEnable = false;
          } else {
            this.document = this.leadTabs[index]['label'];
            this.leadTabs.splice(index, 1);
          }


          index = this.leadTabs.findIndex(x => x.name === 'builderSearchPopup');
          if (index < 0) {
            this.builderSearchPopupEnable = false;
          } else {
            this.builderSearchPopupEnable = true;
            this.builderSearchPopup = this.leadTabs[index]['label'];
            this.leadTabs.splice(index, 1);
          }

          index = this.leadTabs.findIndex(x => x.name === 'invoicebutton');
          if (index < 0) {
            this.invoicebuttonEnable = false;
          } else {
            this.invoicebutton = this.leadTabs[index]['label'];
            this.leadTabs.splice(index, 1);
          }

          index = this.leadTabs.findIndex(x => x.name === 'quotationbutton');
          if (index < 0) {
            this.quotationbuttonEnable = false;
          } else {
            this.quotationbutton = this.leadTabs[index]['label'];
            this.leadTabs.splice(index, 1);
          }


          let retryIndex = this.leadTabs.findIndex(x => x.name === 'retry');
          if (retryIndex < 0) {
            this.leadTabs.push({ name: 'retry', label: 'Retries' });
          }
        }

        // Load data ONLY for the elements that are configured/present across all lead detail page types
        this.loadDataForConfiguredElements(res);
      },
      error => {
        this.type8Loading = false;
        if (this.leadDetailPageType == 7) {
          this.type8Sections = this.getDefaultType8Sections();
          if (this.type8Sections.length > 0) {
            this.selectType8Section(this.type8Sections[0]);
          }
        }
        this.loadDataForConfiguredElements(this.getDefaultType8Sections());
      });
  }

  loadDataForConfiguredElements(res: any): void {
    if (!res || !Array.isArray(res)) return;

    const presentKeys = new Set<string>();
    const normalize = (val: string) => (val || '').toString().toLowerCase().replace(/[\s_-]/g, '');

    const isItemActive = (item: any) => {
      if (!item) return false;
      const active = item.active === undefined || item.active === null || Number(item.active) === 1;
      const visible = item.visible === undefined || item.visible === null || Number(item.visible) === 1;
      return active && visible;
    };

    res.forEach((item: any) => {
      if (item && isItemActive(item)) {
        if (item.name) presentKeys.add(normalize(item.name));
        if (item.componentKey) presentKeys.add(normalize(item.componentKey));
        if (item.label) presentKeys.add(normalize(item.label));

        if (item.leadActivityListMapper && Array.isArray(item.leadActivityListMapper)) {
          item.leadActivityListMapper.forEach((child: any) => {
            if (child && isItemActive(child)) {
              if (child.name) presentKeys.add(normalize(child.name));
              if (child.componentKey) presentKeys.add(normalize(child.componentKey));
              if (child.label) presentKeys.add(normalize(child.label));
            }
          });
        }
      }
    });

    if (this.taskButtonEnable) {
      presentKeys.add('tasks');
      presentKeys.add('task');
      presentKeys.add('taskbutton');
    }
    if (this.leadActionsbuttonEnable) {
      presentKeys.add('leadactionsbutton');
    }
    if (this.sendEmailbutttonEnable || this.sendEmailTemplateEnable) {
      presentKeys.add('email');
      presentKeys.add('sendemailbuttton');
      presentKeys.add('sendemailtemplate');
    }
    if (this.documentEnable) {
      presentKeys.add('documents');
      presentKeys.add('document');
      presentKeys.add('files');
    }

    const hasElement = (...keys: string[]): boolean => {
      return keys.some(k => presentKeys.has(normalize(k)));
    };

    if (hasElement('calls', 'call')) {
      this.getcallList();
    }
    if (hasElement('notes', 'note')) {
      this.getLeadNote(this.leadId);
    }
    if (hasElement('email', 'emails', 'emailstatus', 'emailsent', 'sendemailbuttton', 'sendemailtemplate')) {
      this.getAllEmailSend(this.leadId);
    }
    if (hasElement('deals', 'deal')) {
      this.getConfigData();
    }
    if (hasElement('tasks', 'task', 'taskbutton')) {
      this.typeYFilter();
    }
    if (hasElement('activities', 'activity', 'activitytimeline', 'activityhistory', 'tasks', 'task', 'meetings', 'meeting', 'calls', 'call', 'taskbutton', 'leadactionsbutton')) {
      this.getLeadDropDownList();
    }
    if (hasElement('activities', 'activity', 'activitytimeline', 'activityhistory')) {
      this.getAllLeadActivity(this.leadId);
      this.getAllLeadActivityTasks(this.leadId);
    }
    if (hasElement('documents', 'document', 'files', 'file')) {
      this.getAllDocument();
    }
    if (hasElement('retry', 'retries', 'deals', 'deal')) {
      this.getCount();
    }
  }

  searchText: string = '';

  icons = [
    { icon: 'note', label: 'Create a Note', name: 'Notes' },
    { icon: 'email', label: 'Create an Email', name: 'Email' },
    { icon: 'call', label: 'Make a Phone call', name: 'Call' },
    { icon: 'task', label: 'Create a task', name: 'Task' },
    { icon: 'event', label: 'Shedule a Meeting', name: 'Event' },
    { icon: 'more_vert', label: 'More', name: 'More' }
  ];

  menuItems = ['Option 1', 'Option 2', 'Option 3', 'Option 4'];
  filteredMenuItems() {
    return this.menuItems.filter(item =>
      item.toLowerCase().includes(this.searchText.toLowerCase())
    );
  }

  onMenuItemClick(item: string) {
    console.log('Clicked:', item);
  }

  showDetails = true;
  toggleDetails() {
    this.showDetails = !this.showDetails;
  }
  openCallDialog() { }

  closeDialog() {
    this.dialog.closeAll();
  }




  getConfigData() {
    const encryptedData = localStorage.getItem('configSettingsData');
    if (encryptedData) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encryptedData);
        const data = JSON.parse(decrypted);


        this.storeName = data['storeName'];

        this.baseUrl = data['baseUrl'];

        this.newserverpath = this.baseUrl + '/ecom-gateway/ecom-svc-core-1.0-SNAPSHOT/api/core/download?fileName=image/';
      }
      catch (error) {
        console.error("Failed to decrypt crmSettingsData:", error);
      }
    }
  }

  templateDisplayed: any;

  enableLocation: any;

  enableCallNotes: any;

  enableSequence: boolean = false

  getAllCrmData() {

    const encryptedData = localStorage.getItem('crmSettingsData');
    if (encryptedData) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encryptedData);
        const data = JSON.parse(decrypted);

        if (data != null) {

          if (data['leadDetailPageType'] != undefined) {
            this.leadDetailPageType = data['leadDetailPageType'];
          } else {
            this.leadDetailPageType = 0;
          }
          this.leadPropertiesName = data['leadPropertiesName'];
          this.leadAdditionalPropertiesName = data['leadAdditionalPropertiesName'];
          this.leadCommonPropertiesName = data['leadCommonPropertiesName'];
          this.leadNoteDisplay = data['leadNoteDisplay'];
          this.leadAdditionalPropertiesDisplay = data['leadAdditionalPropertiesDisplay'];
          this.leadCommonPropertiesDisplay = data['leadCommonPropertiesDisplay'];
          this.leadPropertiesDisplay = data['leadPropertiesDisplay'];
          this.crmType = data['crmType'];
          this.additionalAttributeName = data['additionalAttributeName'];
          this.additionalAttributeEnable = data['additionalAttributeEnable'];
          this.enableInvoiceInLead = data['enableInvoiceInLead'];
          this.whatsAppCustomUrl = data['whatsAppCustomUrl'];
          this.whatAppUrl = data['whatAppUrl'];
          this.templateDisplayed = data['templateDisplayed'];
          this.dialerType = data['dialerType'];
          this.authorizationToken = data['authorizationToken'] || '';
          this.dealSetId = data['defaultDealsSet'];
          this.defaultSet = data['defaultSet'];
          this.defaultSetType = data['defaultSetType'];
          this.leadInvoiceType = data['leadInvoiceType'];
          this.leadQuotationType = data['leadQuotationType'];
          this.notesType = data['notesType'];
          this.activityHistoryType = data['activityHistoryType'];
          this.useIndividualMail = data['useIndividualMail'];

          if (this.useIndividualMail == 1) {
            this.fromEmailId.setValidators([Validators.required]);
            this.fromEmail.setValidators([Validators.required]);
          } else {
            this.fromEmailId.clearValidators();
            this.fromEmail.clearValidators();
          }
          this.fromEmailId.updateValueAndValidity();
          this.fromEmail.updateValueAndValidity();

          if (data['webMobileCallEnable'] != undefined) {
            this.webMobileCallEnable = data['webMobileCallEnable'];
          } else {
            this.webMobileCallEnable = 0;
          }

          if (data['manageFieldCustomization'] != undefined) {
            this.manageFieldCustomization = data['manageFieldCustomization'];
          } else {
            this.manageFieldCustomization = 0;
          }

          this.enableSequence = data['enableSequences'] == 1 ? true : false;

          if (this.enableSequence) {

            let index = this.tabs.findIndex(x => x.name === 'Sequences');


            if (index == -1) {

              let object = { name: 'Sequences', icon: 'schedule' };

              this.tabs.push(object);

            }





          }

          this.whatAppchatType = data['whatsappType'] || 1;

          let value = localStorage.getItem(Constant.Sup);

          if (value != undefined) {

            if (value == 'salesUser') {


              this.encryptPhone = data['encryptedPhoneNumber'] == undefined ? 0 : data['encryptedPhoneNumber'];

              this.encryptEmail = data['encryptedEmailId'] == undefined ? 0 : data['encryptedPhoneNumber'];

            } else {
              this.encryptPhone = 0;
              this.encryptEmail = 0;
            }

          } else {
            this.encryptPhone = 0;
            this.encryptEmail = 0;
          }


          this.taskType = data['taskType'] || 1;
          if (this.dialerType == 7) {
            //   this.initDialer();
          }

          this.enableDynamicTabs = data['defaultLeadDetailTab'],

            this.defaultForms = data['defaultForms']

          if (data != null) {

            this.enableLocation = data['enableLocation'];

          } else {
            this.enableLocation = 0;
          }

          if (data != null) {

            this.enableCallNotes = data['enableCallNotes'];

          } else {
            this.enableCallNotes = 0;
          }

          if (this.leadDetailPageType == 5) {
            this.getAllLeadActivityUpcoming();
            this.getAllLeadActivityDue();
            this.getAllLeadActivityCompleted();

          }

          localStorage.setItem(Constant.LEAD_POPUP, data['enableInCallNotification']);



          if (this.enableDynamicTabs == 1 || this.leadDetailPageType == 7) {
            this.getAllLeadActivityList();
          }
          else {

            this.getcallList();
            this.getLeadNote(this.leadId);
            this.getAllEmailSend(this.leadId);
            this.getConfigData();
            this.typeYFilter();
            this.getLeadDropDownList();

            this.getAllLeadActivity(this.leadId);
            this.getAllLeadActivityTasks(this.leadId);

            this.leadTabs = [
              { label: 'Activity History', name: 'activity' },
              { label: 'Lead Detail', name: 'leadDetail' },
              { label: 'Tasks', name: 'tasks' },
              { label: 'Email', name: 'email' },
              { label: 'Chats', name: 'chats' },
              { label: 'Notes', name: 'notes' },
              { label: 'Original Lead Format', name: 'originalLead' },
              { label: 'Documents', name: 'documents' },
              { label: 'Payment', name: 'payment' },
              { label: 'Calendar', name: 'calendar' },
              { label: 'Deals', name: 'deals' },
              { label: 'Calls', name: 'calls' },
            ];
            this.filterTabsForDeal();

          }

        } else {

          this.activityHistoryType = 1;
          this.notesType = 0;
          this.leadDetailPageType = 0;

        }

      } catch (error) {
        console.error("Failed to decrypt crmSettingsData:", error);
      }
    }
  }


  calculateLeadAge(): void {
    const createdDate = new Date(this.LeadDetailsObject.createdDate);

    //console.log(createdDate);

    const currentDate = new Date();
    const timeDiff = Math.abs(currentDate.getTime() - createdDate.getTime());
    const days = Math.floor(timeDiff / (1000 * 3600 * 24));


    if (days === 0) {
      this.leadAge = `${days} Days`;
    } else {
      this.leadAge = `${days} Day${days !== 1 ? 's' : ''} Ago`;
    }

    //console.log(this.leadAge);

  }

  firstFormGroup: FormGroup;


  createFormGroup() {
    this.firstFormGroup = this.fb.group({
      CallDuration: [''],
      Country: [''],
      CreatedBy: [''],
      Description: [''],
      DoNotCall: [''],
      DoNotEmail: [''],
      Email: [''],
      LeadSource: [''],
      LeadStatus: [''],
      Name: [''],
      Notes: [''],
      Owner: [''],
      PhoneNumber: [''],
      ReceiverMobile: [''],
      Address: [''],
      CrNo: [''],
      CrName: [''],
      linkedIn: [''],
      facebook: [''],
      twitter: [''],
    });
  }


  editformGroup(leadset: any) {
    this.emailValue = leadset.email;
    this.phoneValue = leadset.phoneNumber;
    this.firstFormGroup = this.fb.group({
      CallDuration: leadset.callDuration,
      Country: leadset.Country,
      CreatedBy: leadset.createdBy,
      Description: leadset.description,
      DoNotCall: leadset.doNotCall,
      DoNotEmail: leadset.doNotEmail,
      Email: leadset.email,
      LeadSource: leadset.sourceId,
      LeadStatus: leadset.statusId,
      Name: leadset.name,
      Notes: leadset.notes,
      Owner: leadset.Owner,
      PhoneNumber: leadset.phoneNumber,
      ReceiverMobile: leadset.ReceiverMobile,
      statusName: leadset.statusName,
      sourceName: leadset.sourceName,
      statusReason: leadset.statusReason,
      Address: leadset.address,
      CrNo: leadset.CrNo,
      CrName: leadset.CrName,
      linkedIn: '',
      facebook: '',
      twitter: '',

    })

    let finalObject = {
      ...this.customField1,
      ...this.customField2,
      ...this.customField3,
      ...this.customField4,
      ...this.customField5,
      ...this.customField6,
      ...this.customField7,
      ...this.customField8,
      ...this.customField9,
      ...this.customField10,
      ...this.firstFormGroup.value
    };

    this.patchValues = finalObject;
    if (leadset.secondaryLeadStatus !== undefined) {
      this.patchValues.secondaryLeadStatus = leadset.secondaryLeadStatus;
    }


    if (this.defaultForms != null && this.defaultForms != 0 && this.defaultForms !== '') {

      this.getDefaultForm(this.defaultForms);

    } else {

      this.defaultForm = false;

    }
    this.firstFormGroup.get("twitter").setValue(this.LeadDetailsObject.twitter || '');

    this.firstFormGroup.get("facebook").setValue(this.LeadDetailsObject.facebook || '');

    this.firstFormGroup.get("linkedIn").setValue(this.LeadDetailsObject.linkedIn || '');
    this.getLeadStatus();


  }


  mapLink: any;

  getCount() {
    this.dealsService.getDeals(0, 1, this.sortParam, this.type, this.leadId).subscribe(
      res => {

        this.noOfDeals = res['numberOfElements'];

      },
      error => {
        this.spinner = false;
      }
    )

    let sortParam = 'googleCalenderId' + "," + Constant.Dsc;
    this.googleCalendarServiceAccountService.getAllGoogleCalendar(0, 1, sortParam, 1, 2, this.leadId, this.meetingType).subscribe(
      res => {
        this.spinner = false;
        this.noOfMeetings = res['numberOfElements'];
      },
      error => {
      }
    )
  }

  getAllLeadDetails(leadId) {
    this.leadService.getAllLeadDetailsByEntityId(leadId).subscribe(
      data => {


        if (data && data['entityId'] != null) {

          this.getAllCrmData();
          this.getConfigData();
          this.typeYFilter();
          this.getLeadDropDownList();

          this.LeadDetailsObject = data;
          this.loadAfterSalesData();
          // normalize ids to string for consistent select binding
          try {
            if (this.LeadDetailsObject.ownerId !== undefined && this.LeadDetailsObject.ownerId !== null) {
              this.LeadDetailsObject.ownerId = String(this.LeadDetailsObject.ownerId);
            }
            if (this.LeadDetailsObject.statusId !== undefined && this.LeadDetailsObject.statusId !== null) {
              this.LeadDetailsObject.statusId = String(this.LeadDetailsObject.statusId);
            }
          } catch (e) { }
          this.resolveLeadTagName();

          this.uploadedImageUrl = this.basePath + this.LeadDetailsObject.image + this.cid;

          this.updateStars();


          if (this.updateType != 'WalkIn') {
            this.calculateLeadAge();
          }
          this.lifeCycleStage = this.LeadDetailsObject['lifeCycleStage'] || 'Lead';

          this.relatedCompanyId = this.LeadDetailsObject.companyId || 0;

          this.relatedLeadId = this.LeadDetailsObject.leadId || 0;

          this.customField1 = this.LeadDetailsObject.customField1 || {};

          this.customField2 = this.LeadDetailsObject.customField2 || {};

          this.customField3 = this.LeadDetailsObject.customField3 || {};

          this.customField4 = this.LeadDetailsObject.customField4 || {};

          this.customField5 = this.LeadDetailsObject.customField5 || {};


          this.customField6 = this.LeadDetailsObject.customField6 || {};

          this.customField7 = this.LeadDetailsObject.customField7 || {};

          this.customField8 = this.LeadDetailsObject.customField8 || {};


          this.customField9 = this.LeadDetailsObject.customField9 || {};

          this.customField10 = this.LeadDetailsObject.customField10 || {};





          this.companyId = this.LeadDetailsObject.companyId || 0;

          if (this.LeadDetailsObject?.isCustomizedValue?.Google_Map) {

            this.mapLink = this.LeadDetailsObject?.isCustomizedValue?.Google_Map || '';

          } else {

            this.mapLink = this.LeadDetailsObject?.isCustomizedValue?.GoogleMap || '';

          }



          if (this.LeadDetailsObject.ast != null) {
            const keyValuePairs: [string, any][] = Object.entries(JSON.parse(this.LeadDetailsObject.ast));


            this.type1 = true;
            // const keyValuePairs = JSON.parse(this.LeadDetailsObject.ast);
            this.additionalSpecList = keyValuePairs;
            this.additionalSpec = JSON.parse(this.LeadDetailsObject.ast);
          } else {

            this.additionalSpec = this.LeadDetailsObject.additionalSpec;

          }


          if (this.LeadDetailsObject.valuesString != null) {
            const keyValuePairs: [string, any][] = Object.entries(JSON.parse(this.LeadDetailsObject.valuesString));
            this.type2 = true;
            this.valuesList = keyValuePairs;
            this.filterList = JSON.parse(this.LeadDetailsObject.valuesString);
          } else {
            this.filterList = this.LeadDetailsObject.values;
          }

          if (this.LeadDetailsObject.isCustomizedValueString != null) {
            const keyValuePairs: [string, any][] = Object.entries(JSON.parse(this.LeadDetailsObject.isCustomizedValueString));
            this.type3 = true;
            this.customList = keyValuePairs;
            this.usedInSite = JSON.parse(this.LeadDetailsObject.isCustomizedValueString);
          } else {
            this.usedInSite = this.LeadDetailsObject.isCustomizedValue;
          }

          this.jsonRecieved = this.LeadDetailsObject.jsonRecieved;
          this.ownerId = data['ownerId'];






          this.editformGroup(this.LeadDetailsObject);

          this.leadLoaded = true;
          this.loadCategoriesAndProducts();
          this.resolveCategoryAndProductNames();
          this.mapFieldsWithValues();
          this.buildDynamicFieldMapping();






        } else {


          this.snackBar.open('No Data Found!', 'X', {
            duration: 3000,
            verticalPosition: 'bottom',
            panelClass: ['error'],
          });
          this.router.navigate(['lead']);

        }


      },
      error => {

      })
  }
  starsArray = Array(5).fill(0);
  filledStars = 0;
  updateStars() {
    const score = this.LeadDetailsObject?.score || 0;
    // Convert score (0-100) to stars (0-5)
    this.filledStars = Math.round((score / 100) * 5);
  }

  addSiteVisitPopup() {
    if (window.innerWidth > 768) {
      let dialogRef = this.dialog.open(AddSiteVisitComponent, {
        width: '790px',
        height: '600px',
        disableClose: true,
        data: {
          "leadId": this.leadId,
          "leadName": this.LeadDetailsObject?.name || '',
          "assignedAgentId": this.LeadDetailsObject?.ownerId || localStorage.getItem('ID')
        }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result && result['event'] == 'add') {
          this.getAllLeadActivity(this.leadId);
        }
      });
    } else {
      let dialogRef = this.dialog.open(AddSiteVisitComponent, {
        minWidth: '100vw',
        height: '100vh',
        data: {
          "leadId": this.leadId,
          "leadName": this.LeadDetailsObject?.name || '',
          "assignedAgentId": this.LeadDetailsObject?.ownerId || localStorage.getItem('ID')
        },
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result && result['event'] == 'add') {
          this.getAllLeadActivity(this.leadId);
        }
      });
    }
  }


  addLeadActivity(activityType: string, activityId, leadObject: any) {
    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(ConversationPopupComponent, {
        width: '790px',
        height: '600px',
        disableClose: true,
        data: {
          "activityType": activityType,
          "type": "lead",
          "leadId": this.leadId,
          "activityId": activityId,
          "leadObject": leadObject,
          "templateDisplayed": this.templateDisplayed,
          "taskSaveType": 1
        }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {

          this.onTaskUpdated();

        }



      });

    }
    else {
      let dialogRef = this.dialog.open(ConversationPopupComponent, {
        minWidth: '100vw', height: '100vh',
        data: {
          "activityType": activityType,
          "leadId": this.leadId,
          "activityId": activityId,
          "leadObject": leadObject,
          "type": "lead",
          "templateDisplayed": this.templateDisplayed,
          "taskSaveType": 1
        },
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {

          this.onTaskUpdated();

        }


      });
    }

  }

  addLeadActivityone(activityType: string, activityId, leadObject: any) {
    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(ConversationPopupComponent, {
        width: '790px',
        disableClose: true,
        data: {
          "activityType": activityType,
          "type": "lead",
          "leadId": this.leadId,
          "activityId": activityId,
          "leadObject": leadObject,
          "taskSaveType": 1
        }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          this.init = false;
          this.onTaskUpdated();

        }



      });

    }
    else {
      let dialogRef = this.dialog.open(ConversationPopupComponent, {
        minWidth: '100vw', height: '100vh',
        data: {
          "activityType": activityType,
          "leadId": this.leadId,
          "activityId": activityId,
          "leadObject": leadObject,
          "type": "lead",
          "taskSaveType": 1
        },
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          this.init = false;
          this.onTaskUpdated();

        }


      });
    }

  }



  transferLead() {
    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(TransferLeadComponent, {
        width: '790px',
        disableClose: true,
        data: {
          "leadId": this.leadId,
          "ownerId": this.ownerId,
          "randomAssign": 0,
        }

      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {

          if (!this.displayOwner) {
            this.getAllLeadDetails(this.leadId);
          } else {
            this.router.navigate([`/lead`])
          }


          // 

        }
      });

    }
    else {
      let dialogRef = this.dialog.open(TransferLeadComponent, {
        minWidth: '100vw', height: '100vh',
        data: {
          "leadId": this.leadId,
          "ownerId": this.ownerId,
          "randomAssign": 0,
        }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          if (!this.displayOwner) {
            this.getAllLeadDetails(this.leadId);
          } else {
            this.router.navigate([`/lead`])
          }
        }

      });
    }
  }


  newSearch(LeadDetailsObject) {
    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(SearchBuilderComponent, {
        width: '790px',
        disableClose: true,
        data: { data: LeadDetailsObject }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
      });

    }
    else {
      let dialogRef = this.dialog.open(SearchBuilderComponent, {
        minWidth: '100vw', height: '100vh',
        data: { data: LeadDetailsObject }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {

      });
    }
  }

  editFormTwo(event: Event) {
    event.stopPropagation();

    this.formInit = false;
    let index = this.leadStatusList.findIndex(x => x.statusId === this.firstFormGroup.value.LeadStatus);
    if (index > -1) {
      this.patchValues.LeadStatus = this.firstFormGroup.value.LeadStatus
      this.getFormArray(this.leadStatusList[index].dynamicFormGroupId);
    }
    this.editMode = !this.editMode;


  }


  editForm() {

    this.formInit = false;
    let index = this.leadStatusList.findIndex(x => x.statusId === this.firstFormGroup.value.LeadStatus);
    if (index > -1) {
      this.patchValues.LeadStatus = this.firstFormGroup.value.LeadStatus
      this.getFormArray(this.leadStatusList[index].dynamicFormGroupId);
    }
    this.editMode = !this.editMode;


  }


  // save() {

  // }

  close() {
    this.editMode = false;
  }

  public page: any = Constant.PAGE;
  public size: any = Constant.SIZE;
  sortParam: any = 'statusId' + "," + Constant.Dsc;

  type: any = 0;
  currentStatusIndex: number = -1;
  getLeadStatus() {
    this.leadStatusService.LeadStatus(this.page, this.size, this.sortParam, this.type).subscribe(
      res => {
        this.leadStatusList = res['content'];



      },
      error => {
        console.log("Error fetching Lead Status", error);
      }
    );
  }

  checkLeadExist() {

    if ((this.emailValue != this.firstFormGroup.value.Email
      || this.phoneValue != this.firstFormGroup.value.PhoneNumber)) {
      let payload = {
        "Email": this.firstFormGroup.value.Email,
        "PhoneNumber": this.firstFormGroup.value.PhoneNumber,
        "entityId": this.leadId
      }
      this.leadService.leadAlreadyExist(payload).subscribe(
        (response) => {

          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.sameLeadName = true;
            this.saveLead();
          }
          else {
            this.text = "Save"
            this.snackBar.open(response['data']['message'], '×',
              { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
          }
        },
        (err) => {
          this.text = "Save"
          this.sameLeadName = true
        });

      return this.sameLeadName;
    } else {

      this.saveLead()
    }
  }



  saveLead() {
    // this.text = "Processing"

    this.loaderService.show();
    let object = {
      "LeadStatus": this.firstFormGroup.value.LeadStatus,
      "entityId": this.leadId,
      "Name": this.firstFormGroup.value.Name,
      "Email": this.firstFormGroup.value.Email,
      "PhoneNumber": this.firstFormGroup.value.PhoneNumber,
      "Address": this.firstFormGroup.value.Address,
      "CrNo": this.firstFormGroup.value.CrNo,
      "CrName": this.firstFormGroup.value.CrName,
    }

    delete this.finalValueForm['LeadStatus'];
    let finalObject = { ...object, ...this.finalValueForm };

    const firstValue = Object.values(this.finalValueForm)[0];

    if (firstValue != undefined) {

      finalObject['secondaryLeadStatus'] = firstValue;
    }

    object = finalObject

    this.leadService.editLead(object, this.leadId).subscribe(
      (response) => {
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.snackBar.open(response['status_message'] || 'Successfully Updated', '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });
          this.text = "Save";
          this.editMode = false;
          this.isEditMode = false;
          this.getAllLeadDetails(this.leadId);
          this.getAllLeadActivity(this.leadId);


        } else {
          this.text = "Save";
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
        }
        this.loaderService.hide();
      },
      (err) => {
        this.text = "Save";
        this.loaderService.hide();
      });
  }
  callicon(icon) {
    if (icon.icon == 'note') {
      this.createNote(null, 0);
    }
    else if (icon.icon == 'call') {
      this.makeCallConnections(this.LeadDetailsObject);
    }
    else if (icon.icon == 'event') {
      this.router.navigate(['/googleCalender']);
    }
  }
  createNote(note: any, noteId: any) {
    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(CrmNoteComponent, {
        width: '790px',
        disableClose: true,
        data: {
          "leadId": this.leadId,
          "note": note,
          "noteId": noteId,
          "type": 1,
          "designType": 1,
          "crmType": this.notesType,
          "title": " Add Notes to your lead!",
          "ownerId": this.ownerId
        }

      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          this.getLeadNote(this.leadId);
          this.getAllLeadActivityUpcoming();

          this.getAllLeadActivityDue();

          this.getAllLeadActivityCompleted();
        }
      });

    }
    else {
      let dialogRef = this.dialog.open(CrmNoteComponent, {
        minWidth: '100vw', height: '100vh',
        data: {
          "leadId": this.leadId,
          "note": note,
          "noteId": noteId,
          "type": 1,
          "designType": 1,
          "crmType": this.notesType,
          "title": " Add Notes to your lead!",
          "ownerId": this.ownerId
        }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          this.getLeadNote(this.leadId);
          this.getAllLeadActivityUpcoming();

          this.getAllLeadActivityDue();

          this.getAllLeadActivityCompleted();
        }

      });
    }
  }

  createDocument(note: any, noteId: any) {
    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(CrmNoteComponent, {
        width: '790px',
        disableClose: true,
        data: {
          "leadId": this.leadId,
          "note": note,
          "noteId": noteId,
          "type": 1,
          "designType": 2,
          "title": "Attach Document",
          "ownerId": this.ownerId
        }

      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          this.getLeadNote(this.leadId);
        }
      });

    }
    else {
      let dialogRef = this.dialog.open(CrmNoteComponent, {
        minWidth: '100vw', height: '100vh',
        data: {
          "leadId": this.leadId,
          "note": note,
          "noteId": noteId,
          "type": 1,
          "designType": 2,
          "title": "Attach Document",
          "ownerId": this.ownerId
        }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          this.getLeadNote(this.leadId);
        }

      });
    }
  }

  createPayment(note: any, noteId: any) {
    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(CrmNoteComponent, {
        width: '790px',
        disableClose: true,
        data: {
          "leadId": this.leadId,
          "note": note,
          "noteId": noteId,
          "type": 1,
          "designType": 3,
          "title": "Payment",
          "ownerId": this.ownerId
        }

      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          this.getLeadNote(this.leadId);
        }
      });

    }
    else {
      let dialogRef = this.dialog.open(CrmNoteComponent, {
        minWidth: '100vw', height: '100vh',
        data: {
          "leadId": this.leadId,
          "note": note,
          "noteId": noteId,
          "type": 1,
          "designType": 3,
          "title": "Payment",
          "ownerId": this.ownerId
        }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          this.getLeadNote(this.leadId);
        }

      });
    }
  }


  sortParam1: any = 'noteId' + "," + Constant.Dsc;
  sortParam2: any = 'id' + "," + Constant.Dsc;

  getLeadNote(leadId) {

    this.crmNoteService.getAllNoteByLeadId(leadId, "1").subscribe(
      res => {
        this.noteList = res;
      },
      error => {

      }
    )
  }

  toggleReply(noteId: number | null): void {
    if (this.replyingToNoteId === noteId) {
      this.replyingToNoteId = null;
      this.replyText = '';
    } else {
      this.replyingToNoteId = noteId;
      this.replyText = '';
    }
  }

  submitReply(parentNote: any): void {
    if (!this.replyText?.trim()) return;

    const reply = {
      notes: this.replyText.trim(),
      leadId: this.leadId,
      parentNoteId: parentNote.noteId,
      type: 1,
      operationType: 'New',
      noteType: 'REPLY',
      resource: parentNote.resource || ''
    };

    this.crmNoteService.saveReply(reply).subscribe(
      (res: any) => {
        if (res?.['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.snackBar.open(res?.['status_message'] || 'Reply sent', '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });
          this.replyingToNoteId = null;
          this.replyText = '';
          this.getLeadNote(this.leadId);
        } else {
          this.snackBar.open(res?.['status_message'] || 'Failed to send reply', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
        }
      },
      () => {
        this.snackBar.open('Failed to send reply', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
      }
    );
  }


  @ViewChild('delete') delete: TemplateRef<any>;

  deleteLeadDialog(activityId) {

    this.activityId = activityId;
    let dialogRef = this.dialog.open(this.delete, {
      width: '350px',
      disableClose: true,

    });
    dialogRef.disableClose = true;
  }


  submit() {
    this.deleteAllLead(this.id);
    this.dialog.closeAll();
    this.init = false;
    this.getAllLeadActivity(this.leadId);
  }

  resourcePrivilege: any;
  spinner: boolean;

  deleteAllLead(id: any) {
    this.spinner = true;
    this.textAccount = "Processing";
    this.leadActivityService.deleteByLeadActivityId(this.activityId).subscribe(
      response => {
        this.spinner = false;
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          this.getAllLeadActivity(this.leadId);
        } else {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }
        this.textAccount = "OK";
      },
      error => {
        this.textAccount = "OK";
        this.spinner = false;
      })
  }


  @ViewChild('makeConnection') makeConnection: TemplateRef<any>;

  makeCallConnections(LeadDetailsObject) {
    let dialogRef = this.dialog.open(CallListComponent, {
      width: '350px',
      disableClose: true,
      data: { data: LeadDetailsObject }

    });
    dialogRef.disableClose = true;

  }

  makeCall() {
    if (this.textCall == 'Call') {
      this.spinner = true;
      this.leadActivityService.makeCall(this.LeadDetailsObject).subscribe(
        response => {
          this.spinner = false;
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 300 });
            this.dialog.closeAll();
          } else {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 300 });
          }
          this.dialog.closeAll();
        },
        error => {
          this.spinner = false;
        });

    }

  }


  //leadStatus

  filtereddropdownTypeList: any;

  defaultLeadStatus: FormControl = new FormControl('');

  dropdownTypeList: any;
  dropdownList: any;
  protected _onDestroy = new Subject<void>();
  public typeYFilterControl: UntypedFormControl = new UntypedFormControl();


  getLeadDropDownList() {

    this.leadStatusService.getAllLeadStatusDropDown(0).subscribe(
      res => {
        this.dropdownList = res;
        this.dropdownTypeList = res;
        this.filtereddropdownTypeList = this.dropdownTypeList;
        this.currentStatusIndex = this.filtereddropdownTypeList.findIndex(
          s => s.statusName === this.LeadDetailsObject.statusName
        );


      },
      error => {
      })
  }


  typeYFilter() {
    this.typeYFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.typeidYFilter();
      });
  }


  protected typeidYFilter() {
    if (!this.dropdownTypeList) {
      return;
    }
    let search = this.typeYFilterControl.value;
    if (!search) {
      this.filtereddropdownTypeList = this.dropdownTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filtereddropdownTypeList = this.dropdownTypeList.filter(status => status['statusName'].toLowerCase().indexOf(search) > -1)
  }

  getAlldropdowntype() {
    this.filtereddropdownTypeList = this.dropdownTypeList;
  }


  object = {
    "entity_type": "Lead",
    "entity_id": "1",
    "entity_name": "yesh",
    "entity_number": "893972994",
    "tenant_id": " Account Id",
    "user_email": "calsoft_agent01@doocti.com",
    "user_id": "1",
    "user_number": "362"
  }

  @ViewChild('myFrame') myFrame: ElementRef;
  callANumber(number) {

    const iframeWindow = this.myFrame.nativeElement.contentWindow;

    window.addEventListener('message', this.receiveMessage.bind(this));

    const postData = {
      "entity_type": "Lead",
      "entity_id": this.LeadDetailsObject.entityId,
      "entity_name": this.LeadDetailsObject.name,
      "entity_number": this.LeadDetailsObject.phoneNumber.toString(),
      "tenant_id": "Account Id",
      "user_email": this.LeadDetailsObject.ownerEmail,
      "user_id": this.LeadDetailsObject.ownerId,
      "user_number": "362",
    };

    iframeWindow.postMessage({ "data": postData }, 'https://app.doocti.com/');
  }


  receiveMessage(event: MessageEvent) {

    if (event.origin !== 'https://app.doocti.com/') {
      return;
    }

    console.log('Received message from iframe:', event.data);
  }

  opendialCall() {
    document.getElementById("mydailer").style.display = "block";
    this.dialerShow = true;
  }

  dialClose() {
    document.getElementById("mydailer").style.display = "none";
    this.dialerShow = false;
  }

  isMinimized = false;

  minimizeToggle() {
    this.isMinimized = !this.isMinimized;
  }


  download(value) {
    let smallImage = "/coursepdf/" + value;
    this.productService.downloadPdf(smallImage).subscribe(
      data => {
        downloads(data);
      },
    )
  }

  downloadNew(value, type) {

    this.downloadImage(value)

  }

  downloadImage(path) {

    this.downloadImageService.downloadImageNew(path);

  }

  deleteNote(value) {
    this.spinner = true;
    this.textAccount = "Processing";
    this.crmNoteService.deleteByNoteId(value.noteId).subscribe(
      response => {
        this.spinner = false;
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          this.getAllLeadDetails(this.leadId);
          this.getLeadNote(this.leadId)

        } else {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }
        this.textAccount = "OK";
      },
      error => {
        this.textAccount = "OK";
        this.spinner = false;
      })


  }

  back() {
    this.location.back();
  }

  navigateToInvoice(LeadDetailsObject) {
    const encryptedLeadDetailsObject = this.ecryptService.encryptionAES(JSON.stringify(LeadDetailsObject));
    localStorage.setItem('leadDetailObjectData', encryptedLeadDetailsObject);

    this.leadId = LeadDetailsObject.entityId

    if (this.leadInvoiceType === 16) {
      this.router.navigate([`/dynamic-invoice-generator/${this.leadId}`])
    } else if (this.leadInvoiceType >= 12) {
      this.router.navigate([`/invoice-generation-new/${this.leadId}`])
    } else {
      this.router.navigate([`/invoice-generation/${this.leadId}`])
    }

  }
  navigateToQuotation(LeadDetailsObject) {
    const encryptedLeadDetailsObject = this.ecryptService.encryptionAES(JSON.stringify(LeadDetailsObject));
    localStorage.setItem('leadDetailObjectData', encryptedLeadDetailsObject);

    this.leadId = LeadDetailsObject.entityId

    if (this.leadQuotationType === 16) {
      this.router.navigate([`/dynamic-invoice-generator/quotation-generate/${this.leadId}`])
    } else if (this.leadQuotationType >= 12) {
      this.router.navigate([`/invoice-generation-new/quotation-generate/${this.leadId}`])
    } else {
      this.router.navigate([`/invoice-generation/quotation-generate/${this.leadId}`])
    }

  }


  onFormSubmitted(event) {



    this.finalValueForm = event;


  }

  createDynamicForm(event, formGroupId, statusId) {

    if (event.isUserInput != false) {

      this.patchValues.LeadStatus = statusId

      this.formInit = false;

      this.getFormArray(formGroupId)
    }

  }


  regConfig: any[] = [];

  getFormArray(formGroupId) {

    this.dynamicFormLabelService.getDynmaicForm(formGroupId).subscribe((data) => {


      let value: any = data

      if (value.length > 0) {
        this.regConfig = value;

        this.newType = 2;
        this.formInit = true;

        this.defaultForm = true;

        this.changeDetector.detectChanges();
      } else {
        this.defaultForm = false;
        console.log("No form fields found for this Form Group ID");
      }


    });
  }
  toggleFavorite(leadData: any): void {

    leadData.favourite = leadData.favourite == 1 ? 0 : 1;


    let updatedLeadEntity = {

      entityId: leadData.entityId,
      favourite: leadData.favourite

    }

    this.loaderService.show();

    this.leadService.editLead(updatedLeadEntity, leadData.entityId).subscribe(
      response => {

        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          this.text = "Save";
          this.editMode = false;
          this.updateType = 'WalkIn';
          this.getAllLeadDetails(this.leadId);


        } else {
          this.text = "Save";
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }


        this.loaderService.hide();

      },
      error => {
        this.loaderService.hide();

      }
    );
  }

  walkIn(leadData: any): void {

    leadData.walkIn = leadData.walkIn == 1 ? 0 : 1;
    let updatedLeadEntity = {

      entityId: leadData.entityId,
      walkIn: leadData.walkIn

    }
    this.loaderService.show();
    this.leadService.editLead(updatedLeadEntity, leadData.entityId).subscribe(
      response => {

        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          this.text = "Save";
          this.editMode = false;
          this.updateType = 'WalkIn';
          this.getAllLeadDetails(this.leadId);


        } else {
          this.text = "Save";
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }
        this.loaderService.hide();

      },
      error => {
        this.loaderService.hide();

      }
    );
  }

  phonewhatsapp(data) {

    if (this.whatsAppCustomUrl == 0) {

      let message = `Hi ${data.name}, I'm from ${this.storeName}.`;

      let phoneNumber = data.phoneNumber.replace(/\D/g, "");

      let url = `https://wa.me/${encodeURIComponent(phoneNumber)}?text=${encodeURIComponent(message)}`;

      window.open(url, '_blank');

    } else if (this.whatsAppCustomUrl == 2) {
      let contactUid = data?.whatsappContactUid || data?.contactUid || data?.uid;
      let rawPhone = data?.phoneNumber || data?.mobile || data?.phone || '';
      let phoneNumber = rawPhone ? rawPhone.toString().replace(/\D/g, "") : '';
      let target = contactUid || phoneNumber;

      if (target) {
        this.router.navigate(['/whatsAppChat'], { queryParams: { contact: target } });
      } else {
        alert("Contact information not available");
      }
    }
    else {

      let url = this.whatAppUrl;
      if (url != null) {
        window.open(url, '_blank');
      } else {
        alert("Please Update CrmSetting")
      }

    }
  }

  phoneSms(data) {

    let phoneNumber = data.phoneNumber.replace(/\D/g, "");

    // window.location.href = "sms:" + phoneNumber;

    let message = `Hi ${data.name}, I'm from ${this.storeName}.`;

    window.location.href = `sms:${phoneNumber}?&body=${encodeURIComponent(message)}`;

  }

  navigatelink(value) {

    window.open(value, '_blank');

  }

  openEditDialog(): void {
    const dialogRef = this.dialog.open(EditprofileComponent, {
      width: '400px',
      data: {
        firstName: this.LeadDetailsObject.firstName,
        lastName: this.LeadDetailsObject.lastName,
        jobTitle: this.LeadDetailsObject.jobTitle
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.LeadDetailsObject.firstName = result.firstName;
        this.LeadDetailsObject.lastName = result.lastName;
        this.LeadDetailsObject.name = `${result.firstName} ${result.lastName}`;
        this.LeadDetailsObject.jobTitle = result.jobTitle;
      }
    });
  }

  getcallList() {

    let sortParam: any = 'id' + "," + Constant.Dsc;

    // this.search = 'activityType:*OutboundCall,*';

    this.search = `activityType:*OutboundCall,* AND leadId:${this.leadId}`;

    this.spinner = true;
    this.leadActivityService.searchAllActivity(this.search, this.page, this.size, sortParam, this.groupBy).subscribe(
      res => {
        this.spinner = false;
        this.calllist = res['content'];

      },
      error => {
        this.spinner = false;
      })
  }
  openEmailPopup() {
    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(EmailPopupComponentComponent, {
        width: '100vw', // or '100%' depending on your container layout
        maxWidth: '100vw',
        height: '100vh', // optional, for full height too
        maxHeight: '100vh',
        disableClose: true,
        data: {
          email: this.LeadDetailsObject.email,
          name: this.LeadDetailsObject.name,
          leadId: this.leadId,
          type: 1
        }

      });
      dialogRef.afterClosed().subscribe(() => {
        this.getAllLeadDetails(this.leadId);
      });
      dialogRef.disableClose = true;


    }
    else {
      let dialogRef = this.dialog.open(EmailPopupComponentComponent, {
        minWidth: '100vw', height: '100vh',
        data: {
          email: this.LeadDetailsObject.email,
          name: this.LeadDetailsObject.name,
          leadId: this.leadId,
          type: 1
        }
      });
      dialogRef.afterClosed().subscribe(() => {
        this.getAllLeadDetails(this.leadId);
      });
      dialogRef.disableClose = true;



    }

  }

  openSendSmsPopup() {
    let dialogRef = this.dialog.open(SendSmsPopupComponent, {
      width: '750px',
      disableClose: true,
      data: {
        name: this.LeadDetailsObject.name,
        leadId: this.leadId,
        phone: this.LeadDetailsObject.phoneNumber,
      }
    });
    dialogRef.afterClosed().subscribe(() => {
      this.getAllLeadDetails(this.leadId);
    });
    dialogRef.disableClose = true;
  }

  emailtemplateId = new FormControl('', [Validators.required]);
  fromEmailId = new FormControl('', [Validators.required]);
  fromEmail = new FormControl('', [Validators.required]);
  filteredEmaildropdownTypeList: any;
  dropdownEmailTypeList: any;
  dropdownEmailList: any;
  typeEmailYFilterControl: UntypedFormControl = new UntypedFormControl();

  @ViewChild('emailtemplatedata') emailtemplatedata: TemplateRef<any>;

  sendEmailMessage() {
    let dialogRef = this.dialog.open(this.emailtemplatedata, {
      width: '750px',
      disableClose: true,
    });
    dialogRef.disableClose = true;
  }


  // emailTemplateMessage

  protected _onDestroy2 = new Subject<void>();

  emailTemplateMessageList: any;

  filteredEmailTemplateMessageTypeList: any;

  public emailTemplateMessageFilterControl: UntypedFormControl = new UntypedFormControl();

  getEmailTemplateMessageList() {
    this.templateService.getAllEmailSendDropDown().subscribe(
      (res) => {
        this.emailTemplateMessageList = res;
        this.emailTemplateMessageList = this.emailTemplateMessageList;
        this.filteredEmailTemplateMessageTypeList = this.emailTemplateMessageList;
      },
      (error) => { }
    );
  }

  EmailTemplateMessageYFilter() {
    this.emailTemplateMessageFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.EmailTemplateMessageFilter();
      });
  }

  protected EmailTemplateMessageFilter() {
    if (!this.emailTemplateMessageList) {
      return;
    }
    let search = this.emailTemplateMessageFilterControl.value;
    if (!search) {
      this.filteredEmailTemplateMessageTypeList = this.emailTemplateMessageList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }

    this.filteredEmailTemplateMessageTypeList = this.emailTemplateMessageList.filter(
      (dynamicForm) => dynamicForm['templateName'].toLowerCase().indexOf(search) > -1
    );
  }

  getAllEmailTemplateMessage() {
    this.filteredEmailTemplateMessageTypeList = this.emailTemplateMessageList;
  }

  sendMailTemplate() {

    if (!this.LeadDetailsObject?.email) {
      this.snackBar.open("Email address is not available to send the template", '×', {
        panelClass: 'error',
        verticalPosition: 'bottom',
        duration: 500
      });
      return;
    }

    if (this.textSend == 'Send' && this.emailtemplateId.valid && (this.useIndividualMail != 1 || (this.fromEmailId.valid && this.fromEmail.valid))) {

      this.textSend = "Processing"

      const requestBody = [
        {
          leadId: this.leadId,
        }
      ];

      const fromEmailIdVal = this.useIndividualMail == 1 ? this.fromEmailId.value : null;
      const fromEmailVal = this.useIndividualMail == 1 ? this.fromEmail.value : null;

      this.templateService.sendEmailMessage(requestBody, this.emailtemplateId.value, fromEmailIdVal, fromEmailVal).subscribe(
        (response) => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.textSend = "Send";
            this.dialog.closeAll();
            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          }
          else {
            this.dialog.closeAll();
            this.textSend = "Send";
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
          }
        },
        (err) => {
          this.dialog.closeAll();
          this.textSend = "Send"
        });
    }
    else {
      this.emailtemplateId.markAsTouched();
      if (this.useIndividualMail == 1) {
        this.fromEmailId.markAsTouched();
        this.fromEmail.markAsTouched();
      }
    }
  }
  openViewDialog(): void {
    let image = this.LeadDetailsObject?.image;
    this.dialog.open(ProfileEditorDialogComponent, {
      width: '400px', // Set the width of the side panel
      height: '100vh', // Full height
      position: {
        top: '0',
        right: '0' // Position on the right
      },
      panelClass: 'profile-editor-panel', // Apply our custom class for animation
      data: { imageUrl: image }
    }).afterClosed().subscribe(result => {
      if (result) {
        let filename = "";
        let imageUrl = "";
        if (result.action === 'remove') {
          // this.imageChanged.emit('remove');
        } else if (result.action === 'upload') {
          filename = result.fileName;
          imageUrl = result.mediaUrl;

        } else {
          return;
        }


        let object = {
          "entityId": this.leadId,
          "Image": filename
        }

        this.leadService.editLead(object, this.leadId).subscribe(
          (response) => {
            if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
              this.snackBar.open('You added a display picture', '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
              this.text = "Save";
              this.editMode = false;
              this.getAllLeadDetails(this.leadId);


            } else {
              this.text = "Save";
              this.snackBar.open('Something went wrong on our side. Please try again in a minute.', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
            }
            this.loaderService.hide();
          },
          (err) => {
            this.text = "Save";
            this.loaderService.hide();
          });
      }
    });
  }

  phoneNumbercall(data) {

    if (this.webMobileCallEnable == 1) {

      this.leadActivityService.sendWebToMobileCall(data).subscribe(
        (response) => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          }
          else {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
          }
        },
        (err) => { });

    } else {

      if (this.dialerType == 1) {
        this.leadActivityService.makeCall(data).subscribe(
          response => {
            if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 300 });
              this.dialog.closeAll();
            } else {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 300 });
            }
            this.dialog.closeAll();
          },
          error => {

          });
      }
      else if (this.dialerType == 2) {
        this.opendialCallsa(data)
        this.callANumber1(data, data.phoneNumber)
      }

      else if (this.dialerType == 3) {
        this.loaderService.show();
        this.leadActivityService.makeDooctiClickToCall(data).subscribe(
          response => {
            if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 300 });


            } else {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 300 });
            }
            this.loaderService.hide();

          },
          error => {
            this.loaderService.hide();
          });

      }
      else if (this.dialerType == 5 || this.dialerType == 9) {
        this.loaderService.show();
        this.leadActivityService.makeTelecmi(data).subscribe(
          response => {
            if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 300 });


            } else {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 300 });
            }
            this.loaderService.hide();

          },
          error => {
            this.loaderService.hide();
          });

      }
      else if (this.dialerType == 6) {
        this.loaderService.show();
        this.leadActivityService.clickToCallAcefone(data).subscribe(
          response => {
            if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 300 });


            } else {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 300 });
            }
            this.loaderService.hide();

          },
          error => {
            this.loaderService.hide();
          });

      } else if (this.dialerType == 7) {
        this.callANumberNew(data)
      } else if (this.dialerType == 12) {
        this.initiateFrejunCall(data.phoneNumber, data.name);
      }


      else if (this.dialerType == 8) {
        if (window.innerWidth > 768) {

          let dialogRef = this.dialog.open(TwilloDialerComponent, {
            // width: '400px',
            height: 'auto',          // optional
            position: {
              bottom: '2px',        // distance from bottom
              right: '2px'          // distance from right
            },
            disableClose: true,
            data: {
              phone: data.phoneNumber
            }
          });

          dialogRef.disableClose = true;
          dialogRef.afterClosed().subscribe(result => {
            if (result['event'] == 'add') {

            }
          });

        }
        else {
          let dialogRef = this.dialog.open(TwilloDialerComponent, {
            minWidth: '100vw', height: '100vh',
            data: {
              phone: data.phoneNumber
            }
          });
          dialogRef.disableClose = true;
          dialogRef.afterClosed().subscribe(result => {
            if (result['event'] == 'add') {

            }
          });
        }
      }

      else if (this.dialerType == 10) {
        this.loaderService.show();
        this.leadActivityService.callForBuzzDieal(data).subscribe(
          response => {
            if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 300 });


            } else {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 300 });
            }
            this.loaderService.hide();

          },
          error => {
            this.loaderService.hide();
          });

      }

      else if (this.dialerType == 11) {
        this.loaderService.show();
        this.leadActivityService.calltoElevenlabs(data).subscribe(
          response => {
            if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 300 });


            } else {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 300 });
            }
            this.loaderService.hide();

          },
          error => {
            this.loaderService.hide();
          });

      }



      else {

        this.loaderService.hide();

        this.addLeadActivity('Phone Call', 0, data)

      }

    }

  }

  opendialCallsa(data) {
    document.getElementById("mydailer").style.display = "block";
    this.dialerShow = true;
    this.data = data
  }



  callANumber1(number, phone) {

    const iframeWindow = this.myFrame.nativeElement.contentWindow;

    window.addEventListener('message', this.receiveMessage.bind(this));


    const postData = {
      "entity_type": "Lead",
      "entity_id": number.entityId,
      "entity_name": number.name,
      "entity_number": phone.toString(),
      "tenant_id": "Account Id",
      "user_email": number.ownerEmail,
      "user_id": number.ownerId,
      "user_number": "362"
    };

    iframeWindow.postMessage({ "data": postData }, 'https://app.doocti.com/');
  }

  editEmailSend(id) {
    this.router.navigate([`/emailSend/editEmailSend/${id}`])
  }

  emailList: any;

  getAllEmailSend(leadId) {
    this.emailSendService.getAllEmailByLeadId(leadId).subscribe(
      res => {
        this.emailList = res;

      },
      error => {

      }
    )
  }

  groupedActivities: { [key: string]: any[] } = {};
  activeTabInner: string = 'activity';
  activityTabs: any[] = [];
  loadedActivityTabs = new Set<string>();

  selectTabInner(tabName: string): void {
    if (!tabName) tabName = 'activity';
    this.activeTabInner = tabName;
    this.loadActivityTab(tabName);
  }

  loadActivityTab(name: string): void {
    if (!name) name = 'activity';

    const key = name.toLowerCase();
    switch (key) {
      case 'activity':
      case 'activity timeline':
      case 'activities':
        this.getAllLeadActivity(this.leadId);
        break;
      case 'notes':
        this.getLeadNote(this.leadId);
        break;
      case 'tasks':
      case 'task':
        this.getAllLeadActivityTasks(this.leadId);
        this.getAllLeadActivityUpcoming();
        this.getAllLeadActivityDue();
        this.getAllLeadActivityCompleted();
        break;
      case 'calls':
      case 'call':
        this.getcallList();
        break;
      case 'email':
      case 'email sent':
      case 'emailsent':
      case 'email status':
      case 'emailstatus':
        this.getAllEmailSend(this.leadId);
        this.loadEmails({ value: this.currentMailBox || 'INBOX' });
        break;
      default:
        this.getAllLeadActivity(this.leadId);
        break;
    }
  }
  getRelativeTime(dateString: string): string {
    const activityDate = new Date(dateString);
    const now = new Date(); // Using component initialization time for consistency
    const diffInSeconds = Math.floor((now.getTime() - activityDate.getTime()) / 1000);

    const intervals: { [key: string]: number } = {
      'year': 31536000,
      'month': 2592000,
      'day': 86400,
      'hour': 3600,
      'minute': 60
    };

    for (const intervalName in intervals) {
      const interval = intervals[intervalName];
      const count = Math.floor(diffInSeconds / interval);
      if (count > 0) {
        return `${count} ${intervalName}${count > 1 ? 's' : ''} ago`;
      }
    }
    return 'Just now';
  }
  getIconForActivity(type: string): string {
    switch (type.toLowerCase()) {
      case 'task': return 'check_box_outline_blank';
      case 'meeting': return 'groups';
      case 'email': return 'mail_outline';
      case 'stagechange': return 'track_changes';
      case 'ownerchange': return 'person_outline';
      default: return 'history_toggle_off'; // A generic fallback icon
    }
  }
  getAllLeadActivity(leadId) {

    this.onScrollValue = true;

    this.leadActivityService.getAllLeadActivityByPageable(0, 10, 'id,desc', leadId, "1").subscribe(
      data => {

        this.totalSize = data["totalPages"];

        this.leadActivityList = data['content'];


        this.total = data['numberOfElements'];

        this.leadActivityListFinal = data;

        this.processActivities();

        this.init = true;

        this.pagetwo = 0;

        this.loaderService.hide();

      },
      error => {
        this.onScrollValue = false;


      })
  }

  leadActivityListTasks: any = [];
  leadActivityListFinalTasks: any;

  getAllLeadActivityTasks(leadId) {

    this.onScrollValue = true;

    this.leadActivityService.getAllLeadActivityByPageableNew(0, 10, 'id,desc', leadId, "1").subscribe(
      data => {

        this.totalSize = data["totalPages"];

        this.leadActivityListTasks = data['content'];


        this.total = data['numberOfElements'];

        this.leadActivityListFinalTasks = data;

        this.processTasks();

        this.totalActivity = data['totalElements'];

        this.init = true;

        this.pagetwo = 0;

        this.loaderService.hide();

      },
      error => {
        this.onScrollValue = false;


      })
  }

  private processActivities(): void {

    const sortedActivities = this.leadActivityList.sort((a, b) =>
      new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime()
    );

    const groups: { [key: string]: any[] } = {};
    const datePipe = new DatePipe('en-US');

    for (const activity of sortedActivities) {
      const dateKey = datePipe.transform(activity.createdDate, 'MMMM d, yyyy')!;
      if (!groups[dateKey]) {
        groups[dateKey] = [];
      }
      groups[dateKey].push(activity);
    }
    this.groupedActivities = groups;
  }
  private processTasks(): void {
    const list = this.leadActivityListTasks || [];
    this.taskCounts.all = list.length;
    this.taskCounts.completed = list.filter(t => t.isCompleted).length;
    this.taskCounts.overdue = list.filter(t => !t.isCompleted && new Date(t.dueDate) < new Date()).length;
    this.taskCounts.upcoming = list.filter(t => !t.isCompleted && new Date(t.dueDate) >= new Date()).length;

    this.setTaskFilter('all');
  }
  filteredTasks: any[] = [];
  activeTaskFilter: string = 'all';
  setTaskFilter(filter: string): void {
    this.activeTaskFilter = filter;

  }



  pagetwo = 0;
  isMobileView: boolean = false;
  selectedIndex: number | null = null;
  onScroll() {
    if (this.pagetwo < this.totalSize - 1) {
      this.spinner = true;
      this.onScrollValue = true;
      this.pagetwo++;

      this.leadActivityService.getAllLeadActivityByPageable(this.pagetwo, 10, 'id,desc', this.leadId, "1").subscribe(
        res => {
          if (res['content']?.length) {
            this.leadActivityList = [...this.leadActivityList, ...res['content']];
          }

          this.totalSize = res["totalPages"];
          this.isEmpty = res["empty"];
          this.onScrollValue = this.pagetwo < this.totalSize - 1;
          this.spinner = false;
        },
        error => {
          console.error("Error loading activity:", error);
          this.spinner = false;
          this.onScrollValue = false;
        }
      );
    } else {
      this.spinner = false;
      this.onScrollValue = false;
    }
  }


  onScrollNew() {
    if (this.pagetwo < this.totalSize - 1) {
      this.spinner = true;
      this.onScrollValue = false; // prevent multiple triggers

      this.pagetwo++;

      this.leadActivityService
        .getAllLeadActivityByPageable(this.pagetwo, 10, 'id,desc', this.leadId, "1")
        .subscribe(
          res => {
            if (res['content']?.length) {
              this.leadActivityList = [...this.leadActivityList, ...res['content']];
              this.processActivities(); // regroup and update groupedActivities
            }

            this.totalSize = res["totalPages"];
            this.onScrollValue = this.pagetwo < this.totalSize - 1;
            this.spinner = false;
          },
          error => {
            console.error("Error loading more activities:", error);
            this.spinner = false;
            this.onScrollValue = false;
          }
        );
    }
  }




  //for email 
  extractEmailAddress(from: string): string {
    const match = from.match(/<(.+?)>|(\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z]{2,}\b)/i);
    return match ? (match[1] || match[2]) : from;
  }
  truncateText(text: string, limit: number = 150): string {
    return text?.length > limit ? text.substring(0, limit) + '...' : text;
  }


  loadEmails(event?: any) {

    this.isLoading = true;
    this.selectedIndex = null;
    this.emailVisble = false;

    if (!event || !event.value) {
      event = { value: this.currentMailBox || 'INBOX' };
    }

    this.currentMailBox = event.value;

    const emailToFilter = this.LeadDetailsObject?.email;
    let timeoutTriggered = false;
    const loadingTimeout = setTimeout(() => {
      timeoutTriggered = true;
      this.isLoading = false;
      console.warn('Email loading timeout exceeded');
    }, 10000);

    this.mailBox
      .filterByEmail(this.pageIndex, this.pageSizeEmail, event.value, emailToFilter)
      .subscribe({
        next: (response) => {
          if (timeoutTriggered) return;
          this.emails = response['data']['emails']?.map((email: any) => this.transformEmailDto(email)) || [];
          this.totalEmails = response['data']['totalMessages'];
          if (this.emails.length > 0) {
            this.selectEmail(0);
          }
        },
        error: (error) => {
          console.error('Error fetching filtered emails:', error);
        }
      })
      .add(() => {
        if (!timeoutTriggered) {
          clearTimeout(loadingTimeout);
          this.isLoading = false;
        }
      });
  }

  selectEmail(index: number): void {
    this.selectedIndex = index;
    this.emailObject = this.emails[index];
    this.selectedEmail = this.emails[index];
    this.emailVisble = true;
  }


  transformEmailDto(email: any): any {
    const rawBody = email.body && String(email.body).trim();
    const bodyContent = rawBody ? email.body : (email.snippet || '');
    return {
      ...email,
      subject: email.subject || '(No Subject)',
      body: bodyContent,
      attachments: email.attachments || [],
      sentDate: new Date(email.sentDate)
    };
  }
  onPageChange(event: PageEvent) {
    this.pageIndex = event.pageIndex;
    this.pageSizeEmail = event.pageSize;

  }
  linkifyAndSanitize(html: string): SafeHtml {
    if (!html) return '';
    let cleanedHtml = this.extractBodyContent(html);
    if (cleanedHtml && !/<[a-z][\s\S]*>/i.test(cleanedHtml)) {
      cleanedHtml = cleanedHtml.replace(/\r\n|\r|\n/g, '<br>');
    }
    return this.sanitizer.bypassSecurityTrustHtml(cleanedHtml);
  }

  isImage(contentType: string): boolean {
    return contentType ? contentType.startsWith('image/') : false;
  }


  extractBodyContent(html: string): string {
    if (!html) return '';
    const bodyMatch = html.match(/<body[^>]*>([\s\S]*?)<\/body>/i);
    let bodyContent = bodyMatch ? bodyMatch[1] : html;

    bodyContent = bodyContent
      .replace(/<!DOCTYPE[^>]*>/gi, '')
      .replace(/<html[^>]*>|<\/html>/gi, '')
      .replace(/<head[^>]*>[\s\S]*?<\/head>/gi, '')
      .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '')
      .trim();

    return bodyContent;
  }
  //lead activity 
  truncateSafeHTML(html: string, length: number): string {
    const div = document.createElement('div');
    div.innerHTML = html;
    const text = div.innerText || '';
    return text.length > length ? text.substring(0, length) + '…' : text;
  }

  save() {
    this.showEditPopup = false;
  }




  showEditPopup = false;


  openEditPopup1() {
    this.showEditPopup = true;
  }

  closeEditPopup() {
    this.showEditPopup = false;
  }

  @ViewChild(SimpleDynamicFormComponent, { static: false })
  simpleDynamicFormComponent:
    SimpleDynamicFormComponent;
  submitNew() {

    if (this.regConfig.length > 0) {
      this.type = 2;
      this.simpleDynamicFormComponent.onSubmitNew();

    } else {
      this.firstFormGroup.value.dynamicFieldValues = [];
      this.checkLeadExist();
    }


  }

  saveNew(event) {

    this.checkLeadExist();
  }

  defaultConfig: any[] = [];

  getDefaultForm(formGroupId) {

    this.dynamicFormLabelService.getDynmaicForm(formGroupId).subscribe((data) => {


      let value: any = data

      if (value.length > 0) {
        this.defaultConfig = value;

        this.newType = 2;

        this.defaultForm = true;

      } else {
        this.defaultForm = false;
        console.log("No form fields found for this Form Group ID");
      }


    });
  }


  dialerEnable: boolean = false;
  lastDialedNumber: any;

  newdialer(number) {
    this.dialerEnable = true;
    this.lastDialedNumber = number;
    if (this.dialerType == 7) {
      this.callANumberNew(number)
    } else if (this.dialerType == 12) {
      this.initiateFrejunCall(number, this.LeadDetailsObject?.name);
    }

  }

  initiateFrejunCall(candidateNumber: string, candidateName?: string) {
    // Dispatch custom window event — layout.component listens and handles:
    // 1. Shows the dialer card (frejunDialerVisible = true)
    // 2. Posts initiate-call to the single persistent #frejun-global-iframe
    let formattedNumber = candidateNumber ? candidateNumber.toString().trim() : '';
    if (formattedNumber && !formattedNumber.startsWith('+')) {
      formattedNumber = '+' + formattedNumber;
    }

    console.log('FreJun: dispatching initiate-call event', { number: formattedNumber, name: candidateName });
    window.dispatchEvent(new CustomEvent('frejun:initiate-call', {
      detail: {
        number: formattedNumber,
        name: candidateName || ''
      }
    }));
  }


  iframeUrl: string = '';

  initDialer() {

    const userId = localStorage.getItem('userId');
    const companyId = localStorage.getItem('storeName');

    const baseUrl = 'https://client5.rekzyl.com/voice/dialpad';
    const params = new URLSearchParams({
      leftServiceId: '93eeb600-dcb1-4382-bf11-846c467deb79',
      service: 'calsoft',
      sideBar: 'false',
      topBar: 'false',
      fullView: 'false',
      userId: userId,
      companyId: companyId,
    });

    this.iframeUrl = `${baseUrl}?${params.toString()}`;
    this.changeDetector.detectChanges();
  }

  @ViewChild('myHelloSendFrame', { static: false }) myHelloSendFrame: ElementRef;

  onIframeLoaded() {
    setTimeout(() => {
      if (!this.myHelloSendFrame?.nativeElement) {
        console.error('iframe element not yet available');
        return;
      }
      this.callANumberNew(this.lastDialedNumber);
    }, 0);
  }

  callANumberNew(LeadDetailsObject) {
    const iframeWindow = window.frames['myDialerFrame'] as Window;

    if (!iframeWindow) {
      console.error('Iframe window is not available');
      return;
    }


    let phone = "+" + LeadDetailsObject.phoneNumber.toString();

    const postData = {
      entity_type: "Lead",
      entity_id: LeadDetailsObject.entityId,
      entity_name: LeadDetailsObject.name,
      entity_number: phone,
      user_email: LeadDetailsObject.ownerEmail,
      user_id: LeadDetailsObject.ownerId,
      event_action: "click2call"
    };


    iframeWindow.postMessage(postData, 'https://client5.rekzyl.com');

    const messageHandler = (event: MessageEvent) => {
      if (event.origin !== 'https://client5.rekzyl.com') return;
      console.log('Response received from iframe:', event.data);
      window.removeEventListener('message', messageHandler);
    };

    window.addEventListener('message', messageHandler);
  }

  closeDialer() {
    this.dialerEnable = false;
  }

  sendDialPadAction(action: 'MAXIMIZE_DIAL_PAD' | 'MINIMIZE_DIAL_PAD') {
    const iframeWindow = this.myHelloSendFrame?.nativeElement?.contentWindow;

    if (!iframeWindow) {
      console.error('Iframe is not ready to receive messages');
      return;
    }

    const postMessageData = {
      event_action: action
    };

    iframeWindow.postMessage(postMessageData, 'https://client5.rekzyl.com');
  }

  getStars(rating: number): boolean[] {
    return Array(5).fill(false).map((_, i) => i < rating);
  }

  toggleCollapsetwo() {
    this.isCollapsedtwo = !this.isCollapsedtwo;
  }

  activeTab: string = 'Overview';

  selectTabs(tabKey: string): void {
    this.activeTab = tabKey;
    if (tabKey === 'Activities' || tabKey === 'activities' || tabKey === 'activity') {
      this.getAllLeadActivityList();
      const defaultTab = (this.activityTabs && this.activityTabs.length > 0 && this.activityTabs[0]?.name)
        ? this.activityTabs[0].name
        : 'activity';
      this.selectTabInner(this.activeTabInner || defaultTab);
      this.getAllLeadActivity(this.leadId);
    }
    const scrollToTop = () => {
      try {
        window.scrollTo({ top: 0, behavior: 'auto' });
        const scrollContainers = document.querySelectorAll('.content, .right-content-area, .dynamic-content, mat-sidenav-content');
        scrollContainers.forEach(container => {
          const originalScrollBehavior = (container as HTMLElement).style.scrollBehavior;
          (container as HTMLElement).style.scrollBehavior = 'auto';
          container.scrollTop = 0;
          (container as HTMLElement).style.scrollBehavior = originalScrollBehavior;
        });
      } catch (e) {
        console.error('Error scrolling to top:', e);
      }
    };
    scrollToTop();
    setTimeout(scrollToTop, 0);
  }



  openSocialUrl(type: 'facebook' | 'twitter' | 'linkedIn', event: MouseEvent) {
    event.stopPropagation();
    const url = this.firstFormGroup.get(type)?.value;

    if (!url) {
      this.snackBar.open(`No ${type} URL found`, '×', {
        panelClass: 'error',
        duration: 3000
      });
      return;
    }

    this.loaderService.show();
    try {
      const fullUrl = (String(url).trim().startsWith('http')) ? String(url).trim() : `https://${String(url).trim()}`;
      const win = window.open(fullUrl, '_blank');
      if (!win) {
        // popup blocked
        this.snackBar.open(`Could not open ${type} URL`, '×', { panelClass: 'error', duration: 3000 });
      }
    } catch (err) {
      this.snackBar.open(`Invalid ${type} URL`, '×', { panelClass: 'error', duration: 3000 });
    } finally {
      this.loaderService.hide();
    }
  }
  activeView: 'all' | 'basic' = 'all';

  // Manages the state of collapsible sections in the 'All details' view
  isBasicInfoOpen = true;
  isMoreFieldsOpen = true;

  // Static contact data from the images
  contact = {
    email: 'janesampleton@gmail.com',
    firstName: 'Jane',
    lastName: 'Sampleton (sample)',
    jobTitle: 'CEO',
    account: 'Widgetz.io (sample)',
    mobilePhone: '+19266529503',
    workPhone: '+13684932360',
    salesOwner: 'Pavitharan',
    tags: ['Decision maker'],
    source: 'Web',
    address: '604-5854 Beckford St.',
    city: 'Glendale',
    state: 'Arizona',
    country: 'USA',
    zipcode: '100652',
    lifecycleStage: 'Lead',
    status: 'New',
    lostReason: null,
    subscriptionStatus: 'Subscribed',
    subscriptionTypes: 'Newsletter, Promotional, Product updates, Conf...',
    unsubscribeReason: null,
    otherUnsubscribeReasons: null,
    score: 52,
    customerFit: 2, // Representing 2 out of 5 stars
    social: {
      linkedin: 'jane-sampleton-0b0039109',
      twitter: 'janesampleton',
      facebook: '100010587455650'
    }
  };

  // Function to switch between 'All details' and 'Basic information' views
  setView(view: 'all' | 'basic'): void {
    this.activeView = view;
  }

  // Functions to toggle the collapsible sections
  toggleBasicInfo(): void {
    this.isBasicInfoOpen = !this.isBasicInfoOpen;
  }

  toggleMoreFields(): void {
    this.isMoreFieldsOpen = !this.isMoreFieldsOpen;
  }

  goToDeals() {

    let dealId = 0;

    if (this.companyId > 0) {
      this.router.navigate([`deals/add-edit-deals/${dealId}/${this.dealSetId}/${this.leadId}/${this.companyId}`])

    } else {
      this.router.navigate([`deals/add-edit-deals/${dealId}/${this.dealSetId}/${this.leadId}`])
    }




  }

  goToMeeting() {
    const dialogRef = this.dialog.open(AddMeetingComponent, {
      width: '100%',
      maxWidth: '1200px',
      height: '100%',
      data: {
        "leadId": this.leadId,
        "type": 1,
        "leadName": this.LeadDetailsObject.name,
        "email": this.LeadDetailsObject.email
      },
      position: { right: '0' },
      panelClass: 'slide-dialog-panel',
      hasBackdrop: true,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result['event'] === 'add') {
        this.getLeadNote(this.leadId);
        this.getAllLeadActivity(this.leadId);
        this.getAllGoogleCalendar(this.leadId)
      }
    });
  }

  googleCalendarList: any = [];

  getAllGoogleCalendar(leadId) {
    this.spinner = true;

    this.googleCalendarServiceAccountService.getAllGoogleCalendarNew(this.page, this.size, this.sortParam, 1, this.type, leadId, this.meetingType).subscribe(
      res => {
        this.spinner = false;
        this.googleCalendarList = new MatTableDataSource();
        this.googleCalendarList = res['content'];
        this.elements = res['numberOfElements'];
      },
      error => {
      }
    )
  }

  deleteAllProductId() {
    this.spinner = true;
    this.textAccount = "Processing";
    this.productService.deleteByLeadId(this.leadId).subscribe(
      response => {
        this.spinner = false;
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          this.router.navigate([`/lead`])
        } else {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }
        this.textAccount = "OK";
      },
      error => {
        this.textAccount = "OK";
        this.spinner = false;
      })

  }

  editProduct() {

    if (this.defaultSetType == 0) {
      this.router.navigate([`lead/add-edit-lead/${this.leadId}/${this.defaultSet}`])
    } else {
      this.router.navigate([`lead/add-edit-lead/${this.leadId}/${this.defaultSet}`])
    }
  }

  addMeeting() {
    let id = 0;
    this.router.navigate([`/googleCalender/add-edit-google-calender/${id}/${this.leadId}`])
  }

  companyDetailPage(entityId) {
    if (entityId != 0 || entityId != null || entityId != undefined) {

      this.router.navigate([`companiesDetail/${entityId}`])
    }
  }

  createFile(note: any, noteId: any) {
    const dialogRef = this.dialog.open(FileUploadPopupComponent, {
      width: '80%',
      maxWidth: '1200px',
      height: '100%',
      data: {
        "leadId": this.leadId,
        "note": note,
        "noteId": noteId,
        "type": 1,
        "title": "Attach Document"
      },
      position: { right: '0' },
      panelClass: 'slide-dialog-panel',
      hasBackdrop: true,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result['event'] === 'add') {
        this.getLeadNote(this.leadId);
      }
    });
  }

  imageError = false;

  setError() {

    this.imageError = true;
  }


  @ViewChild('tagName') tagName: TemplateRef<any>;

  tagNames: UntypedFormControl = new UntypedFormControl([], [Validators.required]);

  resolveLeadTagName() {
    if (!this.LeadDetailsObject) return;
    let rawTag = this.LeadDetailsObject?.tagName || this.LeadDetailsObject?.tagNames || this.LeadDetailsObject?.Tags || this.LeadDetailsObject?.TagId || this.LeadDetailsObject?.tagIds || '';
    let tagArray: string[] = [];

    if (Array.isArray(rawTag)) {
      tagArray = rawTag.map(t => String(t).trim()).filter(t => !!t);
    } else if (typeof rawTag === 'string' && rawTag.trim().length > 0) {
      tagArray = rawTag.split(',').map(t => t.trim()).filter(t => !!t);
    } else if (rawTag != null && rawTag !== '') {
      tagArray = [String(rawTag).trim()];
    }

    let resolvedNames: string[] = [];
    let resolvedColors: string[] = [];
    tagArray.forEach(item => {
      let matchedTag = (this.tagsList || []).find(t =>
        (t.statusName && (t.statusName === item || t.statusName.toLowerCase() === item.toLowerCase())) ||
        (t.statusId != null && String(t.statusId) === item)
      );
      if (matchedTag) {
        if (!resolvedNames.includes(matchedTag.statusName)) {
          resolvedNames.push(matchedTag.statusName);
        }
        if (matchedTag.statusColor && !resolvedColors.includes(matchedTag.statusColor)) {
          resolvedColors.push(matchedTag.statusColor);
        }
      } else {
        if (!resolvedNames.includes(item)) {
          resolvedNames.push(item);
        }
      }
    });

    if (resolvedNames.length > 0) {
      const joinedNames = resolvedNames.join(', ');
      this.LeadDetailsObject.tagName = joinedNames;
      this.LeadDetailsObject.tagNames = joinedNames;
    }
    if (resolvedColors.length > 0) {
      this.LeadDetailsObject.tagNameColour = resolvedColors[0];
    }
  }

  opentagName() {
    this.tagsFilterControl.setValue('');

    const patchTag = () => {
      this.resolveLeadTagName();
      let rawTag = this.LeadDetailsObject?.tagName || this.LeadDetailsObject?.tagNames || this.LeadDetailsObject?.Tags || this.LeadDetailsObject?.TagId || this.LeadDetailsObject?.tagIds || '';
      let tagArray: string[] = [];

      if (Array.isArray(rawTag)) {
        tagArray = rawTag.map(t => String(t).trim()).filter(t => !!t);
      } else if (typeof rawTag === 'string' && rawTag.trim().length > 0) {
        tagArray = rawTag.split(',').map(t => t.trim()).filter(t => !!t);
      } else if (rawTag != null && rawTag !== '') {
        tagArray = [String(rawTag).trim()];
      }

      let selectedValues: string[] = [];
      tagArray.forEach(item => {
        let matchedTag = (this.tagsList || []).find(t =>
          (t.statusName && (t.statusName === item || t.statusName.toLowerCase() === item.toLowerCase())) ||
          (t.statusId != null && String(t.statusId) === item)
        );
        let targetValue = matchedTag ? matchedTag.statusName : item;
        if (targetValue && !selectedValues.includes(targetValue)) {
          selectedValues.push(targetValue);
        }
      });

      this.tagNames.patchValue(selectedValues);
    };

    if (!this.tagsTypeList || this.tagsTypeList.length === 0) {
      this.getAllTags(() => {
        patchTag();
      });
    } else {
      this.filteredtagsTypeList = this.tagsTypeList.slice();
      patchTag();
    }

    let dialogRef = this.dialog.open(this.tagName, {
      width: '750px',
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(() => {
      this.getAllLeadDetails(this.leadId);
    });
  }

  //Tags

  tagsList: any = [];
  tagsTypeList: any = [];
  filteredtagsTypeList: any = [];
  tagsControl: UntypedFormControl = new UntypedFormControl();
  tagsFilterControl: UntypedFormControl = new UntypedFormControl();


  getAllTags(callback?: Function) {
    this.tagesStatusService.getAllTagsDropDown(5).subscribe(
      data => {
        this.tagsList = data || [];
        this.tagsTypeList = data || [];
        this.filteredtagsTypeList = this.tagsTypeList ? this.tagsTypeList.slice() : [];
        if (this.LeadDetailsObject) {
          this.resolveLeadTagName();
        }
        if (callback) {
          callback();
        }
      },
      error => {
        if (callback) {
          callback();
        }
      }
    )
  }

  TagsYFilter() {
    this.tagsFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.tagsFilter();
      });
  }

  protected tagsFilter() {
    if (!this.tagsTypeList) {
      return;
    }
    // get the search keyword
    let search = this.tagsFilterControl.value;
    if (!search) {
      this.filteredtagsTypeList = this.tagsTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the tags
    this.filteredtagsTypeList = this.tagsTypeList.filter(tags => tags['statusName'] && tags['statusName'].toLowerCase().indexOf(search) > -1)
  }

  setTagName(event, tag) {

    if (event.isUserInput != false) {

      let object = {
        "entityId": this.leadId,
        "TagId": tag.statusId,
        "tagName": tag.statusName,
        "Tags": tag.statusId
      }

      this.tagObject = object;


    }
  }

  submitTagName() {
    if (this.textSubmit == 'Send' && this.tagNames.valid) {

      this.textSubmit = "Processing"

      let object = {
        "entityId": this.leadId,
        "tagName": this.tagNames.value
      }


      this.leadService.editLead(object, this.leadId).subscribe(
        (response) => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.dialog.closeAll();
            // this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          } else {
            this.dialog.closeAll();
            // this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
          }
        },
        (err) => {
        });
    }
    else {
      this.firstFormGroup.markAllAsTouched();
    }
  }

  tagNameUpdate() {

    this.tagSave = "Processing";

    let val = this.tagNames.value;
    let selectedTagNames: string[] = [];
    let selectedTagIds: (string | number)[] = [];
    let selectedColors: string[] = [];

    if (Array.isArray(val)) {
      val.forEach(v => {
        let tagObj = (this.tagsList || []).find(t => t.statusName === v || t.statusId == v);
        if (tagObj) {
          if (!selectedTagNames.includes(tagObj.statusName)) {
            selectedTagNames.push(tagObj.statusName);
          }
          if (!selectedTagIds.includes(tagObj.statusId)) {
            selectedTagIds.push(tagObj.statusId);
          }
          if (tagObj.statusColor && !selectedColors.includes(tagObj.statusColor)) {
            selectedColors.push(tagObj.statusColor);
          }
        } else if (v) {
          if (!selectedTagNames.includes(v)) {
            selectedTagNames.push(v);
          }
        }
      });
    } else if (typeof val === 'string' && val) {
      let tagObj = (this.tagsList || []).find(t => t.statusName === val || t.statusId == val);
      if (tagObj) {
        selectedTagNames.push(tagObj.statusName);
        selectedTagIds.push(tagObj.statusId);
        if (tagObj.statusColor) selectedColors.push(tagObj.statusColor);
      } else {
        selectedTagNames.push(val);
      }
    }

    let joinedNames = selectedTagNames.join(', ');
    let joinedIds = selectedTagIds.join(',');

    let updateObject = {
      "entityId": this.leadId,
      "TagId": joinedIds || null,
      "tagName": joinedNames,
      "tagNames": joinedNames,
      "tagIds": joinedIds,
      "tagNameColour": selectedColors.length > 0 ? selectedColors[0] : '',
      "Tags": joinedIds || null
    };

    this.leadService.editLead(updateObject, this.leadId).subscribe(
      (response) => {
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {

          this.tagSave = "Save";
          if (this.LeadDetailsObject) {
            this.LeadDetailsObject.tagName = joinedNames;
            this.LeadDetailsObject.tagNames = joinedNames;
            this.LeadDetailsObject.tagIds = joinedIds;
            this.LeadDetailsObject.TagId = joinedIds || null;
            this.LeadDetailsObject.Tags = joinedIds || null;
            if (selectedColors.length > 0) {
              this.LeadDetailsObject.tagNameColour = selectedColors[0];
            }
          }
          this.dialog.closeAll();
          this.getAllLeadDetails(this.leadId);
        } else {
          this.tagSave = "Save";
          this.snackBar.open(response['status_message'] || 'Update failed', '×', {
            panelClass: 'error',
            verticalPosition: 'bottom',
            duration: 3000
          });
          this.dialog.closeAll();
        }
      },
      (err) => {
        this.tagSave = "Save";
      }
    );
  }

  editProfileUrl() {

    this.loaderService.show();
    let object = {
      "twitter": this.firstFormGroup.value.twitter,
      "entityId": this.leadId,
      "facebook": this.firstFormGroup.value.facebook,
      "linkedIn": this.firstFormGroup.value.linkedIn,
    }

    delete this.finalValueForm['LeadStatus'];
    let finalObject = { ...object, ...this.finalValueForm };

    const firstValue = Object.values(this.finalValueForm)[0];

    if (firstValue != undefined) {

      finalObject['secondaryLeadStatus'] = firstValue;
    }

    object = finalObject
    this.leadService.editLead(object, this.leadId).subscribe(
      (response) => {
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {

          this.LeadDetailsObject.twitter = this.firstFormGroup.value.twitter
          this.LeadDetailsObject.facebook = this.firstFormGroup.value.facebook
          this.LeadDetailsObject.linkedIn = this.firstFormGroup.value.linkedIn


          this.snackBar.open(response['status_message'] || 'Successfully Updated', '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });
          this.text = "Save";
          this.editMode = false;
          this.getAllLeadDetails(this.leadId);


        } else {
          this.text = "Save";
          this.snackBar.open(response['status_message'] || 'Update failed', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
        }
        this.loaderService.hide();
      },
      (err) => {
        this.text = "Save";
        this.loaderService.hide();
      });
  }

  setStatus(activityType: string, activityId, leadObject: any) {
    // if (window.innerWidth > 768) {

    //   let dialogRef = this.dialog.open(MarkAsCompleteStatusComponent, {
    //     width: '790px',
    //     disableClose: true,
    //     data: {
    //       "activityType": activityType,
    //       "type": "lead",
    //       "leadId": this.leadId,
    //       "activityId": activityId,
    //       "leadObject": leadObject,
    //       "templateDisplayed": this.templateDisplayed,
    //       "taskSaveType": 1
    //     }
    //   });

    //   dialogRef.disableClose = true;
    //   dialogRef.afterClosed().subscribe(result => {
    //     if (result['event'] == 'add') {

    //       this.getAllLeadActivity(this.leadId);

    //     }



    //   });

    // }
    // else {
    //   let dialogRef = this.dialog.open(MarkAsCompleteStatusComponent, {
    //     minWidth: '100vw', height: '100vh',
    //     data: {
    //       "activityType": activityType,
    //       "leadId": this.leadId,
    //       "activityId": activityId,
    //       "leadObject": leadObject,
    //       "type": "lead",
    //       "templateDisplayed": this.templateDisplayed,
    //       "taskSaveType": 1
    //     },
    //   });

    //   dialogRef.disableClose = true;
    //   dialogRef.afterClosed().subscribe(result => {
    //     if (result['event'] == 'add') {

    //       this.getAllLeadActivity(this.leadId);

    //     }


    //   });
    // }

  }

  lostReason() {
    let element = this.LeadDetailsObject;
    let colProperty = "lostReason";
    let value = this.LeadDetailsObject.lostReason
    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(PopupEditComponent, {
        width: '400px',
        height: '214px',
        disableClose: true,
        data: {
          element: element,
          key: colProperty,
          previousValue: value,
          inputType: 'text'
        },

      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          let value = result['data']
          if (value != undefined || value != null) {
            this.LeadDetailsObject.lostReason = value;
            let object: any = {
              entityId: this.leadId,
              lostReason: value
            };
            this.saveLeadObject(object)
          }

        }
      });

    }
    else {
      let dialogRef = this.dialog.open(PopupEditComponent, {
        minWidth: '100vw', height: '100vh',
        disableClose: true,
        data: {
          element: element,
          key: colProperty,
          previousValue: value,
          inputType: 'text'
        },

      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          let value = result['data']

          if (value != undefined || value != null) {
            this.LeadDetailsObject.lostReason = value;
            let object: any = {
              entityId: this.leadId,
              lostReason: value
            };
            this.saveLeadObject(object)
          }

        }

      });
    }
  }

  saveLeadObject(object) {


    this.leadService.editLead(object, this.leadId).subscribe(
      (response) => {
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.getAllLeadActivity(this.leadId);
          this.snackBar.open(response['status_message'], '×', {
            panelClass: 'success',
            verticalPosition: 'bottom',
            duration: 500
          });
        } else {
          this.snackBar.open(response['status_message'], '×', {
            panelClass: 'error',
            verticalPosition: 'bottom',
            duration: 500
          });
        }
      },
      (err) => {
        this.snackBar.open("Save failed", '×', {
          panelClass: 'error',
          verticalPosition: 'bottom',
          duration: 500
        });
      }
    );
  }


  //new type

  total: number;
  leadActivityListUpcoming: any = [];
  leadActivityListFinalUpcoming: any = [];
  leadActivityListCompleted: any = [];
  leadActivityListFinalCompleted: any = [];
  leadActivityListDue: any = [];
  leadActivityListDueFinal: any = [];
  totalCompleted: any = 0;
  totalOverdue: any = 0;
  totalUpcoming: any = 0;
  onScrollValueUpcoming: any = false;
  pagetwoUpComing = 0;

  onScrollValueDue: any = false;
  pagetwoDue = 0;
  totalActivityUpComing: any = 0;

  getAllLeadActivityUpcoming() {


    this.onScrollValueUpcoming = true;

    let search = "a.taskType:*1,* AND a.leadId:*" + this.leadId + ",* AND a.status:*0,* AND a.activityType:*Phone Call,OutboundCall,Follow Up,siteVisit,Site Visit,Outgoing,Incoming,Location,meeting,Meeting,Missed,Not Connected,Call reminder,Call Reminder,*";

    this.activityService.ActivityUpcomingReport(search, 0, 10, 'id,desc', '').subscribe(
      data => {

        this.onScrollValueUpcoming = false;

        this.totalSizeUpcoming = data["totalPages"];

        this.leadActivityListUpcoming = data['content'];

        this.totalUpcoming = data['numberOfElements'];

        this.totalActivityUpComing = data['totalElements']

        this.leadActivityListFinalUpcoming = data;
        this.init = true;

        this.pagetwoUpComing = 0;

      },
      error => {
        this.onScrollValueUpcoming = false;


      })
  }
  pagetwoUpcoming: any;
  totalSizeUpcoming: any;
  onScrollUpcoming() {
    if (this.pagetwoUpcoming < this.totalSizeUpcoming - 1) {
      this.spinner = true;
      this.onScrollValueUpcoming = true;
      this.pagetwoUpcoming++;
      let search = "a.taskType:*1,* AND a.leadId:*" + this.leadId + ",* AND a.status:*0,* AND a.activityType:*Phone Call,OutboundCall,Follow Up,siteVisit,Site Visit,Outgoing,Incoming,Location,meeting,Meeting,Missed,Not Connected,Call reminder,Call Reminder,*";
      this.activityService.ActivityUpcomingReport(search, this.pagetwoUpcoming, 10, 'id,desc', '').subscribe(
        res => {
          if (res['content']?.length) {
            this.leadActivityListUpcoming = [...this.leadActivityListUpcoming, ...res['content']];
          }

          this.totalSizeUpcoming = res["totalPages"];
          this.isEmpty = res["empty"];
          this.onScrollValueUpcoming = this.pagetwo < this.totalSize - 1;
          this.spinner = false;
          this.totalActivityUpComing = res['totalElements']
        },
        error => {
          console.error("Error loading activity:", error);
          this.spinner = false;
          this.onScrollValueUpcoming = false;
        }
      );
    } else {
      this.spinner = false;
      this.onScrollValueUpcoming = false;
    }
  }

  totalDue: any = 0;
  totalActivityDue: any = 0;
  getAllLeadActivityDue() {

    this.onScrollValueDue = true;

    let search = "a.taskType:*1,* AND a.leadId:*" + this.leadId + ",* AND a.status:*0,* AND a.activityType:*Phone Call,OutboundCall,Follow Up,siteVisit,Site Visit,Outgoing,Incoming,Location,meeting,Meeting,Missed,Not Connected,Call reminder,Call Reminder,*";

    this.activityService.searchDynamicLeadReport(search, 0, 10, 'id,desc', '').subscribe(
      data => {

        this.onScrollValueDue = false;

        this.totalSizeDue = data["totalPages"];

        this.leadActivityListDue = data['content'];


        this.totalDue = data['numberOfElements'];

        this.leadActivityListDueFinal = data;

        this.init = true;

        this.pagetwoDue = 0;
        this.totalActivityDue = data['totalElements']

      },
      error => {
        this.onScrollValueDue = false;


      })
  }

  totalSizeDue: any;
  onScrollUpDue() {
    if (this.pagetwoDue < this.totalSizeDue - 1) {
      this.spinner = true;
      this.onScrollValueUpcoming = true;
      this.pagetwoDue++;
      let search = "a.taskType:*1,* AND a.leadId:*" + this.leadId + ",* AND a.status:*0,* AND a.activityType:*Phone Call,OutboundCall,Follow Up,siteVisit,Site Visit,Outgoing,Incoming,Location,meeting,Meeting,Missed,Not Connected,Call reminder,Call Reminder,*";
      this.activityService.searchDynamicLeadReport(search, this.pagetwoDue, 10, 'id,desc', '').subscribe(
        res => {
          if (res['content']?.length) {
            this.leadActivityListDue = [...this.leadActivityListDue, ...res['content']];
          }

          this.totalSizeDue = res["totalPages"];

          this.totalActivityDue = res['totalElements']
          this.isEmpty = res["empty"];
          this.onScrollValueDue = this.pagetwo < this.totalSize - 1;
          this.spinner = false;
        },
        error => {
          console.error("Error loading activity:", error);
          this.spinner = false;
          this.onScrollValueDue = false;
        }
      );
    } else {
      this.spinner = false;
      this.onScrollValueDue = false;
    }
  }

  onScrollValueCompleted: any = false;
  pagetwoCompleted: any = 0;
  totalActivityCompleted: any = 0;

  getAllLeadActivityCompleted() {

    this.onScrollValueCompleted = true;

    let search = "a.taskType:*1,* AND a.leadId:*" + this.leadId + ",* AND a.status:*1,* AND a.activityType:*Phone Call,OutboundCall,Follow Up,siteVisit,Site Visit,Outgoing,Incoming,Location,meeting,Meeting,Missed,Not Connected,Call reminder,Call Reminder,*";

    this.leadActivityService.searchAllActivity(search, 0, 10, 'id,desc', '').subscribe(
      data => {

        this.onScrollValueCompleted = false;

        this.totalSizeCompleted = data["totalPages"];

        this.leadActivityListCompleted = data['content'];

        this.totalCompleted = data['numberOfElements'];

        this.leadActivityListFinalCompleted = data;

        this.init = true;

        this.pagetwoCompleted = 0;

        this.totalActivityCompleted = data['totalElements']

      },
      error => {
        this.onScrollValueCompleted = false;


      })
  }

  totalSizeCompleted: any;
  onScrollUpCompleted() {
    if (this.pagetwoCompleted < this.totalSizeCompleted - 1) {
      this.spinner = true;
      this.onScrollValueUpcoming = true;
      this.pagetwoCompleted++;
      let search = "a.taskType:*1,* AND a.leadId:*" + this.leadId + ",* AND a.status:*1,* AND a.activityType:*Phone Call,OutboundCall,Follow Up,siteVisit,Site Visit,Outgoing,Incoming,Location,meeting,Meeting,Missed,Not Connected,Call reminder,Call Reminder,*";
      this.leadActivityService.searchAllActivity(search, this.pagetwoCompleted, 10, 'id,desc', '').subscribe(
        res => {
          if (res['content']?.length) {
            this.leadActivityListCompleted = [...this.leadActivityListCompleted,
            ...res['content']];
          }

          this.totalSizeCompleted = res["totalPages"];
          this.isEmpty = res["empty"];
          this.onScrollValueCompleted = this.pagetwoCompleted < this.totalSizeCompleted - 1;
          this.spinner = false;
          this.totalActivityCompleted = res['totalElements']
        },
        error => {
          console.error("Error loading activity:", error);
          this.spinner = false;
          this.onScrollValueCompleted = false;
        }
      );
    } else {
      this.spinner = false;
      this.onScrollValueCompleted = false;
    }
  }

  onTaskUpdated() {
    if (this.leadId) {
      this.getAllLeadActivity(this.leadId);
      this.getAllLeadActivityTasks(this.leadId);
      this.getAllLeadActivityUpcoming();
      this.getAllLeadActivityDue();
      this.getAllLeadActivityCompleted();
    }
  }


  updateLeadStatusNew(event, opt) {

    if (event?.isUserInput != false) {

      // If user clicks the current status, do nothing.
      if (opt?.statusName && this.LeadDetailsObject?.statusName === opt.statusName) {
        return;
      }

      // Confirm before changing status.
      const dialogRef = this.dialog.open(ConfirmYesNoDialogComponent, {
        width: '420px',
        maxWidth: '92vw',
        disableClose: true,
        panelClass: 'confirm-yes-no-dialog-panel',
        data: {
          title: 'Confirm',
          message: `Are you sure you want to change status to "${opt?.statusName || ''}"?`,
          confirmText: 'Yes',
          cancelText: 'No'
        }
      });

      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (!confirmed) return;

        let object = {
          "entityId": this.leadId,
          "LeadStatus": opt.statusId
        }

        this.leadService.editLead(object, this.leadId).subscribe(
          (response) => {
            if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
              this.LeadDetailsObject.statusName = opt.statusId;
              this.currentStatusIndex = this.filtereddropdownTypeList.findIndex(
                s => s.statusName === opt.statusName
              );
              this.LeadDetailsObject.statusName = opt.statusName;
              this.getAllLeadActivity(this.leadId);
              this.snackBar.open("Status Updated SuccessFully", '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
            } else {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
            }
          },
          (err) => {
          });
      });

    }
  }

  openEditPopup(field: string, label: string, type: string) {

    let value = this.LeadDetailsObject[field];

    this.previousValue = value;
    if (label == 'State') {
      value = this.LeadDetailsObject.isCustomizedValue?.State
    }

    if (label === 'Status Name') {
      value = this.LeadDetailsObject.statusId;
    }

    if (label === 'Source Name' || label === 'Lead Source') {
      value = this.LeadDetailsObject.sourceId;
    }

    if (label == 'City') {
      value = this.LeadDetailsObject.isCustomizedValue?.City
    }
    if (label == 'Country') {
      value = this.LeadDetailsObject.isCustomizedValue?.Country || this.LeadDetailsObject.country;
    }

    if (label == 'Pincode') {
      value = this.LeadDetailsObject.zipCode
    }

    if (label == 'Address') {
      value = this.LeadDetailsObject.additionalSpec?.Address
    }

    if (label == 'Lifecycle stage') {
      value = this.lifeCycleStage;
    }

    const labelLower = (label || '').toLowerCase();

    if (labelLower.includes('category')) {
      value = this.getFieldValue('Category') ?? this.getFieldValue('category') ?? this.LeadDetailsObject?.category ?? this.LeadDetailsObject?.Category;
    }

    if (labelLower.includes('product')) {
      value = this.getFieldValue('Product') ?? this.getFieldValue('product') ?? this.LeadDetailsObject?.product ?? this.LeadDetailsObject?.Product;
    }


    const dialogRef = this.dialog.open(FieldEditDialogComponent, {
      width: '400px',
      maxHeight: '90vh',
      data: {
        label,
        value: value,
        type,
        element: this.LeadDetailsObject,
        patchValues: this.patchValues
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result !== undefined) {
        const saveValue = (result && result.hasOwnProperty('value')) ? result.value : result;
        const displayValue = (result && result.hasOwnProperty('display')) ? result.display : result;

        if (value === displayValue || value === saveValue) {
          return;
        }

        this.patchResolvedValue(field, displayValue);

        if (value !== displayValue) {
          if (field.toLowerCase() === 'country') {
            this.patchResolvedValue('State', null);
            this.patchResolvedValue('City', null);
          } else if (field.toLowerCase() === 'state') {
            this.patchResolvedValue('City', null);
          }
        }

        if (result?.secondaryFormData) {
          this.patchValues = { ...this.patchValues, ...result.secondaryFormData };
          this.finalValueForm = { ...this.finalValueForm, ...result.secondaryFormData };
        }

        // If the new status has no secondary status, clear the existing secondary status
        if (result?.clearSecondaryStatus) {
          if (this.patchValues) {
            this.patchValues['secondaryLeadStatus'] = '';
            this.patchValues['SecondaryLeadStatus'] = '';
          }
          this.finalValueForm = null;
          this.LeadDetailsObject['secondaryLeadStatus'] = '';
        }

        this.dynamicSaveLead(this.leadId, field, saveValue, this.LeadDetailsObject, result?.clearSecondaryStatus);

      }
    });
  }



  dynamicSaveLead(leadId: any, key: string, value: any, element: any, clearSecondary: boolean = false) {
    let object: any = {
      entityId: leadId,
    };

    const keyLower = (key || '').toLowerCase();

    if (keyLower === 'lifecycle stage' || keyLower === 'lifecyclestage') {
      object['LifeCycleStage'] = value;
    }

    if (keyLower === 'city') {
      if (this.LeadDetailsObject?.isCustomizedValue) {
        this.LeadDetailsObject.isCustomizedValue.City = value;
        this.LeadDetailsObject.isCustomizedValue.city = value;
      }
      object['City'] = value;
      object['city'] = value;
    }

    if (keyLower === 'pincode' || keyLower === 'zipcode') {
      if (this.LeadDetailsObject?.isCustomizedValue) {
        this.LeadDetailsObject.isCustomizedValue.pincode = value;
      }
      object['pincode'] = value;
      object['Zipcode'] = value;
      object['zipcode'] = value;
    }

    if (keyLower === 'state') {
      if (this.LeadDetailsObject?.isCustomizedValue) {
        this.LeadDetailsObject.isCustomizedValue.State = value;
        this.LeadDetailsObject.isCustomizedValue.state = value;
        this.LeadDetailsObject.isCustomizedValue.City = '';
        this.LeadDetailsObject.isCustomizedValue.city = '';
      }
      object['State'] = value;
      object['state'] = value;
      object['City'] = '';
      object['city'] = '';
    }

    if (keyLower === 'country') {
      if (!this.LeadDetailsObject.isCustomizedValue) {
        this.LeadDetailsObject.isCustomizedValue = {};
      }
      this.LeadDetailsObject.isCustomizedValue.Country = value;
      this.LeadDetailsObject.isCustomizedValue.country = value;
      this.LeadDetailsObject.country = value;
      this.LeadDetailsObject.Country = value;
      object['Country'] = value;
      object['country'] = value;

      if (this.LeadDetailsObject.isCustomizedValue) {
        this.LeadDetailsObject.isCustomizedValue.State = '';
        this.LeadDetailsObject.isCustomizedValue.state = '';
        this.LeadDetailsObject.isCustomizedValue.City = '';
        this.LeadDetailsObject.isCustomizedValue.city = '';
      }
      object['State'] = '';
      object['state'] = '';
      object['City'] = '';
      object['city'] = '';
    }

    else if (keyLower === 'category') {
      object['Category'] = value;
      object['category'] = value;
    }

    else if (keyLower === 'product') {
      object['Product'] = value;
      object['product'] = value;
      const catVal = this.getFieldValue('Category') ?? this.getFieldValue('category') ?? this.LeadDetailsObject?.Category ?? this.LeadDetailsObject?.category;
      if (catVal != null && catVal !== '') {
        object['Category'] = catVal;
        object['category'] = catVal;
      }
    }

    else if (keyLower === 'statusname' || keyLower === 'leadstatus') {
      object['LeadStatus'] = value;

      if (clearSecondary) {
        // No secondary status for this lead status — explicitly clear it with empty string
        // (null is ignored by the EAV backend; empty string overwrites the existing value)
        object['secondaryLeadStatus'] = '';
      } else if (this.finalValueForm) {
        delete this.finalValueForm['LeadStatus'];
        let finalObject = { ...object, ...this.finalValueForm };
        const firstValue = this.finalValueForm.secondaryLeadStatus || Object.values(this.finalValueForm)[0];
        if (firstValue !== undefined) {
          finalObject['secondaryLeadStatus'] = firstValue;
        }
        object = finalObject;
      }
    }

    else if (keyLower === 'sourcename' || keyLower === 'leadsource') {
      object['LeadSource'] = value;
    }

    else if (keyLower === 'owneremail' || keyLower === 'owner') {
      object['Owner'] = value;
      object['OwnerName'] = element['OwnerName'];
      object['OwnerId'] = element['OwnerId'];
    }
    else if (keyLower === 'company') {
      object['Company'] = element['Company'];
      object['CompanyId'] = element['CompanyId'];
    }
    else {
      object[key] = value;
    }

    if (keyLower === 'email' || keyLower === 'phonenumber') {
      let payload = {
        Email: keyLower === 'email' ? value : element.email,
        PhoneNumber: keyLower === 'phonenumber' ? value : element.phoneNumber,
        entityId: leadId
      };

      this.leadService.leadAlreadyExist(payload).subscribe(
        (response) => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.doSave(object, leadId);
          } else {

            if (keyLower === 'email') {
              this.LeadDetailsObject.email = this.previousValue;
            }

            if (keyLower === 'phonenumber') {
              this.LeadDetailsObject.phoneNumber = this.previousValue;
            }

            const errorMsg = response?.['data']?.['message'] || response?.['status_message'] || 'Email or phone number already exists';
            this.snackBar.open(errorMsg, '×', {
              panelClass: 'error',
              verticalPosition: 'bottom',
              duration: 3000
            });
          }
        },
        (err) => {

          if (keyLower === 'email') {
            this.LeadDetailsObject.email = this.previousValue;
          }

          if (keyLower === 'phonenumber') {
            this.LeadDetailsObject.phoneNumber = this.previousValue;
          }
          this.snackBar.open("Error validating lead", '×', {
            panelClass: 'error',
            verticalPosition: 'bottom',
            duration: 3000
          });
        }
      );
    }
    else {
      this.doSave(object, leadId);
    }
  }

  doSave(object: any, leadId: any) {
    this.leadService.editLead(object, leadId).subscribe(
      (response) => {
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {

          this.getAllLeadDetails(this.leadId)

          this.snackBar.open(response['status_message'] || 'Successfully Updated', '×', {
            panelClass: 'success',
            verticalPosition: 'bottom',
            duration: 3000
          });


        } else {
          this.snackBar.open(response['status_message'], '×', {
            panelClass: 'error',
            verticalPosition: 'bottom',
            duration: 3000
          });
        }
      },
      (err) => {
        this.snackBar.open("Save failed", '×', {
          panelClass: 'error',
          verticalPosition: 'bottom',
          duration: 500
        });
      }
    );
  }

  addLeadActivityNew(activityType: string, activityId, leadObject: any, taskType: any) {
    if (leadObject && (leadObject.activityType?.toLowerCase() === 'sitevisit' || leadObject.activityType?.toLowerCase() === 'site visit' || leadObject.activityType?.toLowerCase() === 'site_visit')) {
      this.addSiteVisitPopup();
      return;
    }
    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(ConversationPopupComponent, {
        width: '790px',
        height: '600px',
        disableClose: true,
        data: {
          "activityType": activityType,
          "type": "1",
          "leadId": this.leadId,
          "activityId": activityId,
          "leadObject": leadObject,
          "templateDisplayed": this.templateDisplayed,
          "taskSaveType": this.type,
          "taskType": taskType,

        }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          this.onTaskUpdated();

        }



      });

    }
    else {
      let dialogRef = this.dialog.open(ConversationPopupComponent, {
        minWidth: '100vw', height: '100vh',
        data: {
          "activityType": activityType,
          "leadId": this.leadId,
          "activityId": activityId,
          "leadObject": leadObject,
          "type": "1",
          "templateDisplayed": this.templateDisplayed,
          "taskSaveType": this.type,
          "taskType": taskType
        },
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {

          this.onTaskUpdated();

        }


      });
    }

  }

  documentDownload = new FormControl('', [Validators.required]);

  @ViewChild('downloadDocument') downloadDocument: TemplateRef<any>;

  downloadDocumentPopup() {
    let dialogRef = this.dialog.open(this.downloadDocument, {
      width: '750px',
      disableClose: true,
    });
    dialogRef.disableClose = true;
  }
  columns: any;
  filterSelectObj: any;
  documentDownloadList: any;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  getAllDocument() {

    let sortParam = 'noteId' + "," + Constant.Dsc;
    this.documentService.getAllDocument(this.page, this.size, sortParam).subscribe(
      res => {
        this.spinner = false;
        this.documentList = new MatTableDataSource();
        this.documentList = res['content'];
        this.elements = res['numberOfElements'];
        this.documentList.sort = this.sort;
        this.documentList.paginator = this.paginator;
        this.pageList = res['totalElements'];
        this.pageSizeValue = getPageSize(this.pageList);

      },
      error => {
      }
    )
  }

  paginationDetail = new BehaviorSubject(
    {
      length: 10,
      pageIndex: 0,
      pageSize: 10
    });

  getUpdate(event) {
    this.paginationDetail.next(event);
    this.page = event.pageIndex;
    this.size = event.pageSize;
    this.DetectingRequestType();
  }


  DetectingRequestType() {
    if (!this.filterActive) {
      this.getAllDocument();
    }
    else {
      this.filterOption(this.search);
    }
  }

  filterActive: boolean = false;
  documentList: any = [];
  elements: any;
  pageList: any;

  pageSizeValue: any;
  filterOption(event) {
    this.filterActive = true;
    this.search = event;
    this.spinner = true;
    let sortParam = 'noteId' + "," + Constant.Dsc;
    this.documentService.documentSearch(this.search, this.page, this.size, sortParam).subscribe(
      res => {
        this.spinner = false;
        this.documentList = res['content'];
        this.elements = res['numberOfElements'];
        this.pageList = res['totalElements'];
        this.pageSizeValue = getPageSize(this.pageList);
      },
      error => {
        this.spinner = false;
      })

  }



  onFilterChangeColumn(i) {
    if (i == undefined) {
      this.filterActive = false
      this.getAllDocument();
    } else {
      this.page = Constant.PAGE;
      this.size = Constant.SIZE;
      this.filterOption(i)
    }
    this.loaderService.hide();
  }

  onFilterChange(value) {
    if (value == '') {
      this.getAllDocument();
    } else {
      this.page = Constant.PAGE;

      let searchTerm = "notesDocument:'" + '*' + value.trim() + '*'
        + "'  AND type:" + 5
      this.filterOption(searchTerm)
    }

  }



  setViewNew(view: 'Original' | 'basic'): void {
    this.activeViewNew = view;
    if (this.activeViewNew == 'basic') {
      this.getAllManageContactFields();
    }
  }




  copyToClipboard(text: string) {
    navigator.clipboard.writeText(text || '');
    this.snackBar.open('Copied to clipboard!', 'X', {
      duration: 3000,
      verticalPosition: 'bottom',
      panelClass: ['success'],
    });
  }



  searchTextOriginal = '';
  searchTextBasic = '';

  filteredJsonRecieved: any = {};
  filteredUsedInSite: any = {};
  filteredFilterList: any = {};
  filteredAdditionalSpec: any = {};


  initializeFilteredData() {
    this.filteredJsonRecieved = this.jsonRecieved;
    this.filteredUsedInSite = this.usedInSite;
    this.filteredFilterList = this.filterList;
    this.filteredAdditionalSpec = this.additionalSpec;
  }

  // -------------------- ORIGINAL --------------------
  applySearchOriginal() {
    const text = this.searchTextOriginal.toLowerCase();
    if (!text) {
      this.filteredJsonRecieved = this.jsonRecieved;
      return;
    }
    this.filteredJsonRecieved = Object.fromEntries(
      Object.entries(this.jsonRecieved || {}).filter(([key, value]) =>
        key.toLowerCase().includes(text) ||
        ('' + value).toLowerCase().includes(text)
      )
    );
  }

  resetSearchOriginal() {
    this.searchTextOriginal = '';
    this.filteredJsonRecieved = this.jsonRecieved;
  }

  // -------------------- BASIC --------------------
  applySearchBasic() {
    const text = this.searchTextBasic.toLowerCase();
    if (!text) {
      this.filteredUsedInSite = this.usedInSite;
      this.filteredFilterList = this.filterList;
      this.filteredAdditionalSpec = this.additionalSpec;
      return;
    }

    this.filteredUsedInSite = Object.fromEntries(
      Object.entries(this.usedInSite || {}).filter(([key, value]) =>
        key.toLowerCase().includes(text) || ('' + value).toLowerCase().includes(text)
      )
    );
    this.filteredFilterList = Object.fromEntries(
      Object.entries(this.filterList || {}).filter(([key, value]) =>
        key.toLowerCase().includes(text) || ('' + value).toLowerCase().includes(text)
      )
    );
    this.filteredAdditionalSpec = Object.fromEntries(
      Object.entries(this.additionalSpec || {}).filter(([key, value]) =>
        key.toLowerCase().includes(text) || ('' + value).toLowerCase().includes(text)
      )
    );
  }

  resetSearchBasic() {
    this.searchTextBasic = '';
    this.filteredUsedInSite = this.usedInSite;
    this.filteredFilterList = this.filterList;
    this.filteredAdditionalSpec = this.additionalSpec;
  }



  globalSearchText: string = '';
  searchTabIndex: number = 0;
  isSearching: boolean = false;

  onSearchChange1() {

    this.isSearching = this.globalSearchText.trim().length > 0;


  }
  onGlobalSearchChange(value: string) {
    if (!value) {
      this.resetSearch();
      return;
    }

    const searchValue = value.toLowerCase().trim();

    // 1. First, check if the search matches a field which belongs to a specific tab
    const mappedTabName = Object.keys(this.fieldTabMapping).find(key => key.includes(searchValue));
    if (mappedTabName) {
      const targetTabName = this.fieldTabMapping[mappedTabName];
      this.switchToTabByName(targetTabName);

      // Delay slightly to allow the tab content to render before highlighting
      setTimeout(() => this.onSearchChange(), 100);
      return;
    }

    // 2. Check if it matches a Tab label/name directly
    if (this.leadTabs && this.leadTabs.length > 0) {
      const index = this.leadTabs.findIndex(tab =>
        tab.label?.toLowerCase().includes(searchValue) ||
        tab.name?.toLowerCase().includes(searchValue)
      );

      if (index !== -1) {
        this.searchTabIndex = index;
        if (this.leadDetailPageType === 5) {
          this.setActiveTab(this.leadTabs[index].name);
        }
        setTimeout(() => this.onSearchChange(), 100);
        return;
      }
    }

    // 3. Check simple tabs (Overview, My Views, etc.)
    const simpleTab = this.tabs.find(t => t.name.toLowerCase().includes(searchValue));
    if (simpleTab) {
      this.switchToTabByName(simpleTab.name);
      setTimeout(() => this.onSearchChange(), 100);
      return;
    }

    // Default: just search in current view
    this.onSearchChange();
  }

  /**
   * Helper to switch tabs across different layout types
   */
  private switchToTabByName(tabName: string) {
    // For Material Tabs style (leadDetailPageType 3, 4, etc.)
    if (this.leadTabs) {
      const index = this.leadTabs.findIndex(t => t.name.toLowerCase() === tabName.toLowerCase());
      if (index !== -1) {
        this.searchTabIndex = index;
      }
    }

    // For Sidebar style (leadDetailPageType 5)
    this.setActiveTab(tabName);

    // For other styles that use selectedTab
    this.selectedTab = tabName.toLowerCase();

    this.changeDetector.detectChanges();
  }
  onGlobalSearchBackspace(event: KeyboardEvent) {
    const current = (this.globalSearchText || '');
    if (current.length <= 1) {
      this.globalSearchText = '';
      this.resetSearch();
    }
  }

  onSearchChange() {
    const searchValue = this.globalSearchText?.trim().toLowerCase();
    if (!searchValue) return;

    // Remove old highlights
    document.querySelectorAll('.highlight').forEach(el => el.classList.remove('highlight'));

    // Select all text nodes or relevant visible elements
    const allElements = document.querySelectorAll('label, h3, h4, p, span, td, th');
    let foundElement: HTMLElement | null = null;

    for (const el of Array.from(allElements)) {
      const element = el as HTMLElement;
      if (element.textContent?.toLowerCase().includes(searchValue)) {
        // Prefer elements that are visible and closer to being labels
        if (element.offsetParent !== null) {
          foundElement = element;
          break;
        }
      }
    }

    if (foundElement) {
      foundElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      foundElement.classList.add('highlight');

      // Keep highlights for a reasonable time or until next search
      this.highlightedElements.push(foundElement);
    }
  }

  highlightedElements: HTMLElement[] = [];

  // onSearchChange() {
  //   const searchValue = this.globalSearchText.trim().toLowerCase();

  //   // Clear old highlights
  //   this.highlightedElements.forEach(el => el.classList.remove('highlight'));
  //   this.highlightedElements = [];

  //   if (!searchValue) return;

  //   // Target only inside the active tab’s container
  //   const activeContainer = document.querySelector('.dynamic-content [ngswitchcase="' + this.activeTab + '"]')
  //     || document.querySelector('.dynamic-content');
  //   if (!activeContainer) return;

  //   const elements = Array.from(
  //     activeContainer.querySelectorAll(
  //       'label, span, div.value-display a, div.value-display span, p, a, h1, h2, h3'
  //     )
  //   ) as HTMLElement[];

  //   elements.forEach((el) => {
  //     const text = el.innerText?.trim().toLowerCase();
  //     if (text && text.includes(searchValue)) {
  //       el.classList.add('highlight');
  //       this.highlightedElements.push(el);
  //     }
  //   });

  //   // Scroll to first match (optional)
  //   if (this.highlightedElements.length > 0) {
  //     this.highlightedElements[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
  //     this.isSearching = this.globalSearchText.trim().length > 0;
  //   }
  // }


  resetSearch() {
    this.globalSearchText = '';
    this.isSearching = false;
    this.searchTabIndex = 0;
    this.highlightedElements.forEach(el => el.classList.remove('highlight'));
    this.highlightedElements = [];
  }

  getRelativeTimenew(dateString: string): string {
    if (!dateString) return '';

    const activityDate = new Date(dateString);
    const now = new Date();
    const diffInSeconds = Math.floor((now.getTime() - activityDate.getTime()) / 1000);
    const diffInHours = diffInSeconds / 3600;

    // If the note is older than 24 hours → show date & time
    if (diffInHours >= 24) {
      const day = String(activityDate.getDate()).padStart(2, '0');
      const month = String(activityDate.getMonth() + 1).padStart(2, '0');
      const year = activityDate.getFullYear();

      const hours = String(activityDate.getHours()).padStart(2, '0');
      const minutes = String(activityDate.getMinutes()).padStart(2, '0');

      return `${day}.${month}.${year} ${hours}:${minutes}`;
    }

    // Else → show relative time (e.g., 5 minutes ago, 2 hours ago)
    const intervals: { [key: string]: number } = {
      'hour': 3600,
      'minute': 60,
    };

    for (const intervalName in intervals) {
      const interval = intervals[intervalName];
      const count = Math.floor(diffInSeconds / interval);
      if (count > 0) {
        return `${count} ${intervalName}${count > 1 ? 's' : ''} ago`;
      }
    }

    return 'Just now';
  }

  goToCompany() {

    if (this.LeadDetailsObject.companyId == 0 || this.LeadDetailsObject.companyId == null) {
      this.snackBar.open('No Company Associated', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
      return;
    }

    this.router.navigate([`companiesDetail/${this.LeadDetailsObject.companyId}`])
  }

  phoneNumbercallSecondary(data) {

    data['phoneNumber'] = data.secondaryphoneno;

    if (this.dialerType == 1) {
      this.leadActivityService.makeCall(data).subscribe(
        response => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 300 });
            this.dialog.closeAll();
          } else {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 300 });
          }
          this.dialog.closeAll();
        },
        error => {

        });
    }
    else if (this.dialerType == 2) {
      this.opendialCallsa(data)
      this.callANumber1(data, data.phoneNumber)
    }

    else if (this.dialerType == 3) {
      this.loaderService.show();
      this.leadActivityService.makeDooctiClickToCall(data).subscribe(
        response => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 300 });


          } else {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 300 });
          }
          this.loaderService.hide();

        },
        error => {
          this.loaderService.hide();
        });

    }
    else if (this.dialerType == 5) {
      this.loaderService.show();
      this.leadActivityService.makeTelecmi(data).subscribe(
        response => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 300 });


          } else {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 300 });
          }
          this.loaderService.hide();

        },
        error => {
          this.loaderService.hide();
        });

    }
    else if (this.dialerType == 6) {
      this.loaderService.show();
      this.leadActivityService.clickToCallAcefone(data).subscribe(
        response => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 300 });


          } else {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 300 });
          }
          this.loaderService.hide();

        },
        error => {
          this.loaderService.hide();
        });

    }
    else {

      this.loaderService.hide();

      let phonenumber;

      if (data.phoneNumber.startsWith("91")) {
        phonenumber = "+" + data.phoneNumber;
      }
      else {
        phonenumber = data.phoneNumber;
      }


      window.location.href = "tel:" + phonenumber;

    }
  }


  addDeal(dealId: number, companyId: number) {
    this.router.navigate(['/deals/add-edit-deals', dealId, companyId]);
  }

  manageFields() {
    this.router.navigate([`/fieldDesigner/${this.leadId}`])
  }

  manageFieldsList: any;

  getAllManageContactFields() {
    this.fieldDesignerService.getAllContactFieldsDropDown()
      .subscribe(
        res => {
          this.manageFieldsList = res;
          this.mapFieldsWithValues();

        },
        error => {
        })
  }



  openEditPopupNew(fieldKey: string, label: string, type: string, fieldRef: any) {
    const normKey = this.normalizeKey(fieldKey);
    if (['notes', 'note'].includes(normKey)) {
      return;
    }

    if (fieldKey && fieldKey.toLowerCase().includes('owner')) {
      this.transferLead();
      return;
    }

    if (fieldKey && fieldKey.toLowerCase().includes('tag')) {
      this.opentagName();
      return;
    }


    let value = this.getFieldValue(fieldKey);

    if (
      ['leadstatus', 'leadsource']
        .includes(this.normalizeKey(fieldKey)) &&
      value !== null &&
      value !== undefined &&
      !isNaN(Number(value))
    ) {
      value = Number(value);
    }


    this.previousValue = value;

    const dialogRef = this.dialog.open(FieldEditDialogComponent, {
      width: '400px',
      data: {
        label,
        value,
        type,
        element: this.LeadDetailsObject,
        fieldRef,
        optionValues: fieldRef.optionValues,
        optionId: fieldRef.optionId,
        isRequired: fieldRef.isRequired,
        patchValues: this.patchValues
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === undefined) return;

      const saveValue = (result && typeof result === 'object' && result.hasOwnProperty('value')) ? result.value : result;
      const displayValue = this.getDisplayValue(fieldKey, (result && typeof result === 'object' && result.hasOwnProperty('display')) ? result.display : saveValue);

      fieldRef.rawValue = saveValue;
      fieldRef.value = displayValue;


      this.patchResolvedValue(fieldKey, displayValue);

      if (result?.secondaryFormData) {
        this.patchValues = { ...this.patchValues, ...result.secondaryFormData };
        this.finalValueForm = { ...this.finalValueForm, ...result.secondaryFormData };
      }

      this.mapFieldsWithValues();

      this.dynamicSaveLead(
        this.leadId,
        fieldKey,
        saveValue,
        this.LeadDetailsObject
      );
    });
  }

  patchResolvedValue(fieldKey: string, value: any) {
    const normalized = this.normalizeKey(fieldKey);

    if (normalized === 'owner') {
      this.LeadDetailsObject.ownerEmail = value;
      return;
    }

    if (normalized === 'category') {
      this.LeadDetailsObject.category = value;
      this.LeadDetailsObject.Category = value;
    }
    if (normalized === 'product') {
      this.LeadDetailsObject.product = value;
      this.LeadDetailsObject.Product = value;
    }

    const targets = [
      this.LeadDetailsObject,
      this.LeadDetailsObject.values,
      this.LeadDetailsObject.additionalSpec,
      this.LeadDetailsObject.isCustomizedValue,
      this.patchValues
    ];

    for (const target of targets) {
      if (!target) continue;

      for (const key of Object.keys(target)) {
        if (this.normalizeKey(key) === normalized) {
          target[key] = value;
        }
      }
    }
  }







  categoryList: any[] = [];
  productList: any[] = [];

  loadCategoriesAndProducts() {
    if (this.categoriesService) {
      this.categoriesService.getAllCategories(0, 1000, 'id,desc').subscribe(
        (res: any) => {
          this.categoryList = res['content'] || res || [];
          this.resolveCategoryAndProductNames();
        },
        () => { }
      );
    }
    if (this.productService) {
      this.productService.getProductByType(0, 500, 'id,desc', '').subscribe(
        (res: any) => {
          this.productList = res['content'] || res || [];
          this.resolveCategoryAndProductNames();
        },
        () => { }
      );
    }
  }

  resolveCategoryAndProductNames() {
    if (!this.LeadDetailsObject) return;

    const rawCat = this.getFieldValue('Category') ?? this.getFieldValue('category') ?? this.LeadDetailsObject?.category ?? this.LeadDetailsObject?.Category;
    if (rawCat != null && String(rawCat).trim() !== '') {
      const valStr = String(rawCat).trim().toLowerCase();
      const matchCat = this.categoryList.find((c: any) =>
        String(c.id ?? c.categoryId ?? '').toLowerCase() === valStr ||
        String(c.name ?? c.categoryName ?? '').trim().toLowerCase() === valStr
      );
      if (matchCat) {
        const catName = matchCat.name ?? matchCat.categoryName;
        this.LeadDetailsObject.category = catName;
        this.LeadDetailsObject.Category = catName;
      } else if (isNaN(Number(rawCat))) {
        this.LeadDetailsObject.category = rawCat;
        this.LeadDetailsObject.Category = rawCat;
      }
    }

    const rawProd = this.getFieldValue('Product') ?? this.getFieldValue('product') ?? this.LeadDetailsObject?.product ?? this.LeadDetailsObject?.Product;
    if (rawProd != null && String(rawProd).trim() !== '') {
      const valStr = String(rawProd).trim().toLowerCase();
      const matchProd = this.productList.find((p: any) =>
        String(p.id ?? p.entityId ?? p.productId ?? '').toLowerCase() === valStr ||
        String(p.name ?? '').trim().toLowerCase() === valStr
      );
      if (matchProd) {
        this.LeadDetailsObject.product = matchProd.name;
        this.LeadDetailsObject.Product = matchProd.name;
      } else if (isNaN(Number(rawProd))) {
        this.LeadDetailsObject.product = rawProd;
        this.LeadDetailsObject.Product = rawProd;
      }
    }

    this.mapFieldsWithValues();
    if (this.changeDetector) {
      this.changeDetector.markForCheck();
    }
  }

  resolveNameFromList(type: string, rawValue: any): string | null {
    if (rawValue == null || String(rawValue).trim() === '') return null;
    const valStr = String(rawValue).trim().toLowerCase();
    if (type === 'category') {
      const match = this.categoryList.find((c: any) =>
        String(c.id ?? c.categoryId ?? '').toLowerCase() === valStr ||
        String(c.name ?? c.categoryName ?? '').trim().toLowerCase() === valStr
      );
      return match ? (match.name ?? match.categoryName) : null;
    }
    if (type === 'product') {
      const match = this.productList.find((p: any) =>
        String(p.id ?? p.entityId ?? p.productId ?? '').toLowerCase() === valStr ||
        String(p.name ?? '').trim().toLowerCase() === valStr
      );
      return match ? match.name : null;
    }
    return null;
  }

  mappedGroups: any[] = [];

  mapFieldsWithValues() {
    if (!this.manageFieldsList || !this.LeadDetailsObject) return;

    this.mappedGroups = this.manageFieldsList
      .filter(group => group.isActive === 1)
      .map(group => ({
        groupName: group.groupName,
        fields: group.contactFields
          .filter(field => {
            if (field.isActive !== 1) return false;

            const norm = this.normalizeKey(field.fieldKey);
            if (norm === 'state') {
              const countryValue = this.getFieldValue('Country');
              if (!countryValue) return false;
            }
            if (norm === 'city') {
              const stateValue = this.getFieldValue('State');
              if (!stateValue) return false;
            }

            const hiddenFields = ['originaldata', 'opendealamountcount', 'wondealamountcount'];
            if (hiddenFields.includes(norm)) return false;

            return true;
          })
          .map(field => {
            const rawValue = this.getFieldValue(field.fieldKey);
            const norm = this.normalizeKey(field.fieldKey);

            const readOnlyFields = ['opendealamount', 'opendealsamount', 'wondealamount', 'score', 'notes', 'note'];
            let isReadOnly = field.isReadOnly;
            if (readOnlyFields.includes(norm)) {
              isReadOnly = true;
            }

            return {
              fieldId: field.fieldId,
              fieldName: field.fieldName,
              fieldKey: field.fieldKey,
              fieldType: field.fieldType,
              isReadOnly: isReadOnly,
              rawValue,
              value: this.getDisplayValue(field.fieldKey, rawValue),
              optionValues: field.optionValues,
              optionId: field.optionId,
              isRequired: field.isRequired
            };
          })
      }));
  }

  getDisplayValue(fieldKey: string, rawValue: any): any {
    if (!this.LeadDetailsObject) return rawValue;

    switch (this.normalizeKey(fieldKey)) {

      case 'leadstatus':
        return this.LeadDetailsObject.statusName ?? rawValue;

      case 'leadsource':
        return this.LeadDetailsObject.sourceName ?? rawValue;

      case 'category':
        return this.LeadDetailsObject?.category ?? this.LeadDetailsObject?.Category ?? this.resolveNameFromList('category', rawValue) ?? rawValue;

      case 'product':
        return this.LeadDetailsObject?.product ?? this.LeadDetailsObject?.Product ?? this.resolveNameFromList('product', rawValue) ?? rawValue;

      default:
        return rawValue;
    }
  }

  getFieldValue(fieldKey: string): any {
    if (!this.LeadDetailsObject) return null;

    const normalized = this.normalizeKey(fieldKey);

    if (normalized === 'owner') {
      return this.LeadDetailsObject.ownerEmail ?? null;
    }

    // For category and product: check nested EAV sources first to get the numeric ID,
    // not the stale text name that may be stored in the root object.
    const isCategoryOrProduct = normalized === 'category' || normalized === 'product';

    const nestedSources = [
      this.LeadDetailsObject.values,
      this.LeadDetailsObject.additionalSpec,
      this.LeadDetailsObject.isCustomizedValue,
      this.LeadDetailsObject.jsonRecieved,
      this.LeadDetailsObject.customField1,
      this.LeadDetailsObject.customField2,
      this.LeadDetailsObject.customField3,
      this.LeadDetailsObject.customField4,
      this.LeadDetailsObject.customField5,
      this.LeadDetailsObject.customField6,
      this.LeadDetailsObject.customField7,
      this.LeadDetailsObject.customField8,
      this.LeadDetailsObject.customField9,
      this.LeadDetailsObject.customField10
    ];

    const sources = isCategoryOrProduct
      ? [...nestedSources, this.LeadDetailsObject]
      : [this.LeadDetailsObject, ...nestedSources];

    for (const source of sources) {
      if (!source) continue;

      for (const key of Object.keys(source)) {
        if (this.normalizeKey(key) === normalized) {
          const val = source[key];
          if (val !== null && val !== undefined && String(val).trim() !== '') {
            return val;
          }
        }
      }
    }

    return null;
  }

  private normalizeKey(key: string): string {
    return key
      .toLowerCase()
      .replace(/\s+/g, '')
      .replace(/_/g, '');
  }

  ngOnDestroy() {

    this._onDestroy.next();
    this._onDestroy.complete();
  }

  // User list fed into collaboration components
  collaborationUsers: any[] = [];

  loadCollaborationUsers() {
    if (this.collaborationUsers.length > 0) { return; }
    try {
      this.usersService.getAllUserStatusDropDownSales().subscribe(
        (res: any) => {
          this.collaborationUsers = (res || []).map((u: any) => ({
            id: u.entityId ?? u.userId ?? u.id,
            name: u.name ?? u.userName ?? u.ownerName ?? u.email,
            email: u.email ?? u.ownerEmail ?? ''
          }));
        },
        () => { }
      );
    } catch (e) { }
  }

  get currentUserObj(): any {
    return {
      id: this.userId,
      name: localStorage.getItem('userName') ?? localStorage.getItem('email') ?? ''
    };
  }

  getAllUserMailConfig() {
    this.userMailConfigService.getAllUserMailConfig().subscribe(res => {
      this.dropdownEmailList = res;
      this.dropdownEmailTypeList = res;
      this.filteredEmaildropdownTypeList = this.dropdownEmailTypeList;

      if (this.useIndividualMail == 1 && this.dropdownEmailList && this.dropdownEmailList.length > 0) {
        this.fromEmailId.patchValue(this.dropdownEmailList[0].userMailConfigId);
        this.fromEmail.patchValue(this.dropdownEmailList[0].emailAddress);
      } else {
        this.fromEmailId.patchValue('');
        this.fromEmail.patchValue('');
      }
    },
      error => {
      })
  }

  typeEmailYFilter() {
    this.typeEmailYFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.typeidEmailYFilter();
      });
  }

  protected typeidEmailYFilter() {
    if (!this.dropdownEmailTypeList) {
      return;
    }
    let search = this.typeEmailYFilterControl.value;
    if (!search) {
      this.filteredEmaildropdownTypeList = this.dropdownEmailTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredEmaildropdownTypeList = this.dropdownEmailTypeList.filter(status => status['emailAddress'].toLowerCase().indexOf(search) > -1)
  }

  onFromEmailChange(userMailConfigId: any) {
    if (!this.dropdownEmailTypeList) {
      return;
    }
    const selected = this.dropdownEmailTypeList.find(opt => opt.userMailConfigId === userMailConfigId);
    if (selected) {
      this.fromEmail.setValue(selected.emailAddress);
    }
  }


  afterSalesPipelineStages: any[] = [];
  currentAfterSalesStageIndex: number = 0;
  afterSalesSubStatuses: any[] = [];

  loadAfterSalesData() {
    if (this.LeadDetailsObject && this.LeadDetailsObject.afterSalesPipelineId) {
      // Load pipeline stages
      fetch(environment.serverAPI9 + `/api/dealsPipeLine/status/${this.LeadDetailsObject.afterSalesPipelineId}`, {
        headers: {
          'x-tenant': localStorage.getItem('tenantId') || '',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      })
        .then(res => res.json())
        .then(data => {
          this.afterSalesPipelineStages = data;
          let idx = data.findIndex((s: any) => s.pipelineStageId == this.LeadDetailsObject.afterSalesStageId);
          this.currentAfterSalesStageIndex = idx >= 0 ? idx : 0;
        })
        .catch(e => console.error(e));

      // Load sub-statuses for current stage
      if (this.LeadDetailsObject.afterSalesStageId) {
        fetch(environment.serverAPI9 + `/api/after-sales-sub-status/dropdown?pipelineStageId=${this.LeadDetailsObject.afterSalesStageId}`, {
          headers: {
            'x-tenant': localStorage.getItem('tenantId') || '',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        })
          .then(res => res.json())
          .then(data => {
            this.afterSalesSubStatuses = data;
          })
          .catch(e => console.error(e));
      }
    }
  }

  updateAfterSalesSubStatus(subStatusId: any) {
    fetch(environment.serverAPI9 + `/api/deals/${this.LeadDetailsObject.entityId}/after-sales/sub-status/${subStatusId}`, {
      method: 'PUT',
      headers: {
        'x-tenant': localStorage.getItem('tenantId') || '',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    })
      .then(res => {
        if (res.ok) {
          this.snackBar.open("After-Sales Sub-Status updated", 'Close', { duration: 3000 });
          this.getAllLeadDetails(this.LeadDetailsObject.entityId);
        } else {
          this.snackBar.open("Failed to update Sub-Status", 'Close', { duration: 3000 });
        }
      })
      .catch(e => {
        console.error(e);
        this.snackBar.open("Error updating Sub-Status", 'Close', { duration: 3000 });
      });
  }

  // ==========================================
  // Type-8 Fully Dynamic Layout Configuration
  // ==========================================
  type8Sections: any[] = [];
  activeType8Section: any = null;
  activeType8ChildTab: any = null;
  activeType8ComponentKey: string = '';
  type8Loading: boolean = false;
  Number = Number;
  type8ApprovedKeys: string[] = [
    'overview', 'myViews', 'contactDetails', 'activities', 'company',
    'deals', 'nextAction', 'files', 'sequences', 'activity',
    'notes', 'tasks', 'meetings', 'chats', 'email', 'calls',
    'emailStatus', 'leadInformation', 'originalLeadFormat', 'allDetails', 'basicInformation'
  ];

  type8IconMap: { [key: string]: string } = {
    overview: 'grid_view',
    myviews: 'user_attributes',
    contactdetails: 'person',
    activities: 'task_alt',
    company: 'domain',
    deals: 'monetization_on',
    nextaction: 'psychology',
    files: 'folder',
    sequences: 'schedule',
    activity: 'history',
    notes: 'note',
    tasks: 'task',
    meetings: 'event',
    chats: 'chat',
    email: 'email',
    calls: 'call',
    emailstatus: 'mark_email_read',
    leadinformation: 'info',
    originalleadformat: 'description',
    alldetails: 'list_alt',
    basicinformation: 'badge'
  };

  loadType8DynamicConfiguration(): void {
    this.getAllLeadActivityList();
  }

  getDefaultType8Sections(): any[] {
    return [
      {
        activityListId: 1001,
        label: 'Overview',
        componentKey: 'overview',
        icon: 'grid_view',
        type: 1,
        position: 0,
        active: 1,
        visible: 1,
        leadActivityListMapper: []
      },
      {
        activityListId: 1002,
        label: 'My Views',
        componentKey: 'myViews',
        icon: 'user_attributes',
        type: 1,
        position: 1,
        active: 1,
        visible: 1,
        leadActivityListMapper: []
      },
      {
        activityListId: 1003,
        label: 'Contact details',
        componentKey: 'contactDetails',
        icon: 'person',
        type: 1,
        position: 2,
        active: 1,
        visible: 1,
        leadActivityListMapper: []
      },
      {
        activityListId: 1004,
        label: 'Activities',
        componentKey: 'activities',
        icon: 'task_alt',
        type: 0,
        position: 3,
        active: 1,
        visible: 1,
        leadActivityListMapper: [
          { mapperId: 2001, label: 'Activity', componentKey: 'activity', name: 'activity', position: 0, active: 1, visible: 1 },
          { mapperId: 2002, label: 'Notes', componentKey: 'notes', name: 'notes', position: 1, active: 1, visible: 1 },
          { mapperId: 2003, label: 'Tasks', componentKey: 'tasks', name: 'tasks', position: 2, active: 1, visible: 1 },
          { mapperId: 2004, label: 'Meetings', componentKey: 'meetings', name: 'meetings', position: 3, active: 1, visible: 1 },
          { mapperId: 2005, label: 'Chats', componentKey: 'chats', name: 'chats', position: 4, active: 1, visible: 1 },
          { mapperId: 2006, label: 'Email', componentKey: 'email', name: 'email', position: 5, active: 1, visible: 1 },
          { mapperId: 2007, label: 'Calls', componentKey: 'calls', name: 'calls', position: 6, active: 1, visible: 1 }
        ]
      },
      {
        activityListId: 1005,
        label: 'Company',
        componentKey: 'company',
        icon: 'domain',
        type: 1,
        position: 4,
        active: 1,
        visible: 1,
        leadActivityListMapper: []
      },
      {
        activityListId: 1006,
        label: 'Deals',
        componentKey: 'deals',
        icon: 'monetization_on',
        type: 1,
        position: 5,
        active: 1,
        visible: 1,
        leadActivityListMapper: []
      },
      {
        activityListId: 1007,
        label: 'Next Action',
        componentKey: 'nextAction',
        icon: 'psychology',
        type: 1,
        position: 6,
        active: 1,
        visible: 1,
        leadActivityListMapper: []
      },
      {
        activityListId: 1008,
        label: 'Files',
        componentKey: 'files',
        icon: 'folder',
        type: 1,
        position: 7,
        active: 1,
        visible: 1,
        leadActivityListMapper: []
      },
      {
        activityListId: 1009,
        label: 'Sequences',
        componentKey: 'sequences',
        icon: 'schedule',
        type: 1,
        position: 8,
        active: 1,
        visible: 1,
        leadActivityListMapper: []
      }
    ];
  }

  selectType8Section(section: any): void {
    if (!section) return;
    this.activeType8Section = section;
    const activeChildren = this.getActiveChildTabs(section);

    if (activeChildren.length > 0) {
      this.selectType8ChildTab(activeChildren[0]);
    } else {
      this.activeType8ChildTab = null;
      this.activeType8ComponentKey = this.normalizeType8Key(section.componentKey || section.name || section.label || '');
      if (this.activeType8ComponentKey) {
        this.loadType8ComponentData(this.activeType8ComponentKey);
      }
    }
  }

  selectType8ChildTab(childTab: any): void {
    if (!childTab) return;
    this.activeType8ChildTab = childTab;
    this.activeType8ComponentKey = this.normalizeType8Key(childTab.componentKey || childTab.name || childTab.label || '');
    this.loadType8ComponentData(this.activeType8ComponentKey);
  }

  getActiveChildTabs(section: any): any[] {
    if (!section) return [];
    if (Number(section.type) === 1) return [];
    const list = section.leadActivityListMapper || section.leadActivityListMappers || section.activityListMapper || section.leadActivityMappers || section.mappers || [];
    if (!Array.isArray(list)) return [];
    return list.filter((m: any) =>
      m && (m.active === undefined || m.active === null || Number(m.active) === 1 || m.active === true || m.active === '1') &&
      (m.visible === undefined || m.visible === null || Number(m.visible) === 1 || m.visible === true || m.visible === '1')
    );
  }

  isChildTabActive(child: any): boolean {
    if (!child || !this.activeType8ChildTab) return false;
    if (this.activeType8ChildTab === child) return true;
    if (this.activeType8ChildTab.activityListMapperId && child.activityListMapperId && this.activeType8ChildTab.activityListMapperId === child.activityListMapperId) return true;
    if (this.activeType8ChildTab.leadActivityListMapperId && child.leadActivityListMapperId && this.activeType8ChildTab.leadActivityListMapperId === child.leadActivityListMapperId) return true;
    if (this.activeType8ChildTab.id && child.id && this.activeType8ChildTab.id === child.id) return true;
    if (this.activeType8ChildTab.label && child.label && this.activeType8ChildTab.label === child.label) return true;
    const activeKey = this.normalizeType8Key(this.activeType8ChildTab.componentKey || this.activeType8ChildTab.name || this.activeType8ChildTab.label || '');
    const currentKey = this.normalizeType8Key(child.componentKey || child.name || child.label || '');
    return !!activeKey && activeKey === currentKey;
  }

  normalizeType8Key(key: string): string {
    if (!key) return '';
    const trimmed = key.trim();
    const compactKey = trimmed.toLowerCase().replace(/\s+/g, '').replace(/_/g, '');
    const match = this.type8ApprovedKeys.find(k => k.toLowerCase() === compactKey);
    if (match) return match;
    const lower = trimmed.toLowerCase();
    if (lower === 'activity' || lower === 'activity timeline' || lower === 'activity history') return 'activity';
    if (lower === 'activities') return 'activities';
    if (lower === 'notes' || lower === 'note') return 'notes';
    if (lower === 'tasks' || lower === 'task') return 'tasks';
    if (lower === 'meetings' || lower === 'meeting') return 'meetings';
    if (lower === 'chats' || lower === 'chat' || lower === 'whatsapp') return 'chats';
    if (lower === 'email' || lower === 'emails' || lower === 'email sent' || lower === 'emailsent') return 'email';
    if (lower === 'calls' || lower === 'call' || lower === 'call history') return 'calls';
    if (lower === 'emailstatus' || lower === 'email status' || lower === 'email logs') return 'emailStatus';
    if (lower === 'company' || lower === 'companies') return 'company';
    if (lower === 'deals' || lower === 'deal') return 'deals';
    if (lower === 'nextaction' || lower === 'next action' || lower === 'next best action') return 'nextAction';
    if (lower === 'files' || lower === 'documents' || lower === 'document' || lower === 'attachments') return 'files';
    if (lower === 'sequences' || lower === 'sequence') return 'sequences';
    if (lower === 'leadinformation' || lower === 'lead info' || lower === 'lead details' || lower === 'lead information') return 'leadInformation';
    if (lower === 'originalleadformat' || lower === 'original lead' || lower === 'original' || lower === 'original lead format') return 'originalLeadFormat';
    if (lower === 'alldetails' || lower === 'all details') return 'allDetails';
    if (lower === 'basicinformation' || lower === 'basic information' || lower === 'basic info') return 'basicInformation';
    if (lower === 'overview') return 'overview';
    if (lower === 'myviews' || lower === 'my views') return 'myViews';
    if (lower === 'contactdetails' || lower === 'contact details') return 'contactDetails';
    return key;
  }

  isType8KeyValid(key: string): boolean {
    if (!key) return false;
    const norm = this.normalizeType8Key(key);
    return this.type8ApprovedKeys.includes(norm);
  }

  getType8Icon(section: any): string {
    if (section && section.icon && section.icon.trim()) {
      return section.icon.trim();
    }
    const key = (this.normalizeType8Key(section?.componentKey || section?.name || section?.label || '') || '').toLowerCase().replace(/\s+/g, '').replace(/_/g, '');
    return this.type8IconMap[key] || 'view_quilt';
  }

  loadType8ComponentData(key: string): void {
    if (!key) return;
    const norm = this.normalizeType8Key(key);
    switch (norm) {
      case 'activities':
      case 'activity':
        this.getAllLeadActivity(this.leadId);
        break;
      case 'notes':
        this.getLeadNote(this.leadId);
        break;
      case 'calls':
        this.getcallList();
        break;
      case 'email':
      case 'emailStatus':
        this.getAllEmailSend(this.leadId);
        this.loadEmails({ value: this.currentMailBox || 'INBOX' });
        break;
      case 'deals':
        this.getCount();
        break;
      case 'files':
        this.getAllDocument();
        break;
      case 'overview':
      case 'myViews':
      case 'contactDetails':
      case 'allDetails':
      case 'basicInformation':
      case 'leadInformation':
      case 'originalLeadFormat':
        if (norm === 'basicInformation') {
          this.activeView = 'basic';
        } else if (norm === 'allDetails' || norm === 'contactDetails') {
          this.activeView = 'all';
        }
        if (norm === 'originalLeadFormat') {
          this.activeViewNew = 'Original';
        } else if (norm === 'leadInformation' || norm === 'myViews') {
          this.activeViewNew = 'basic';
        }
        this.mapFieldsWithValues();
        break;
      default:
        break;
    }
  }
}








